// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const GA: IClientSubSystemModel = {
  Code: 'GA',
  DisplayLabel: 'Grav',
  BusinessModels: {
    GAGravAnmarkning: {
      CollectionName: 'GAGravAnmarkning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravAnmarkning',
        Abstract: false,
        SOLabel: 'Anmärkning',
        SOGLabel: 'Anmärknings',
        SBLabel: 'Anmärkningen',
        SBGLabel: 'Anmärkningens',
        POLabel: 'Anmärkningar',
        POGLabel: 'Anmärkningars',
        PBLabel: 'Anmärkningarna',
        PBGLabel: 'Anmärkningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Anmärkningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Anmärkningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Anmärkningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Anmärkningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ATGARD: {
          AttributeName: 'ATGARD',
          DisplayLabel: 'Åtgärd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OMBESIKTNING: {
          AttributeName: 'OMBESIKTNING',
          DisplayLabel: 'Ombesiktningsregel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAGravMaterial: {
      CollectionName: 'GAGravMaterial',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravMaterial',
        Abstract: false,
        SOLabel: 'Material',
        SOGLabel: 'Materials',
        SBLabel: 'Materialet',
        SBGLabel: 'Materialets',
        POLabel: 'Materialen',
        POGLabel: 'Materialens',
        PBLabel: 'Materialen',
        PBGLabel: 'Materialens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Materialets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Materialets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Materialets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Materialets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAGravYta: {
      CollectionName: 'GAGravYta',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravYta',
        Abstract: false,
        SOLabel: 'Ytbeläggning',
        SOGLabel: 'Ytbeläggnings',
        SBLabel: 'Ytbeläggningen',
        SBGLabel: 'Ytbeläggningens',
        POLabel: 'Ytbeläggningar',
        POGLabel: 'Ytbeläggningars',
        PBLabel: 'Ytbeläggningarna',
        PBGLabel: 'Ytbeläggningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ytbeläggningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ytbeläggningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ytbeläggningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ytbeläggningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAMyCartaWeb: {
      CollectionName: 'GAMyCartaWeb',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: '',
        Abstract: true,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GAMyCartaWebs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GAMyCartaWebs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GAMyCartaWebs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DISPLAY_NAME: {
          AttributeName: 'DISPLAY_NAME',
          DisplayLabel: 'Visningsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILE_NAME: {
          AttributeName: 'FILE_NAME',
          DisplayLabel: 'Filnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CREATED_BY: {
          AttributeName: 'CREATED_BY',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CREATED_DATE: {
          AttributeName: 'CREATED_DATE',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        CHANGED_BY: {
          AttributeName: 'CHANGED_BY',
          DisplayLabel: 'Ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        CHANGED_DATE: {
          AttributeName: 'CHANGED_DATE',
          DisplayLabel: 'Ändrad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAGravHandelseAnsvarig: {
      CollectionName: 'GAGravHandelseAnsvarig',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '48']]),
      RootType: {
        TypeValue: 'GravHandelseAnsvarigSaml',
        Abstract: false,
        SOLabel: 'Ansvarig',
        SOGLabel: 'Ansvarigs',
        SBLabel: 'Den ansvariga',
        SBGLabel: 'Den ansvarigas',
        POLabel: 'Ansvariga',
        POGLabel: 'Ansvarigas',
        PBLabel: 'De ansvariga',
        PBGLabel: 'De ansvarigas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Den ansvarigas primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Den ansvarigas versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Den ansvarigas id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Den ansvarigas fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EMAIL: {
          AttributeName: 'EMAIL',
          DisplayLabel: 'Email',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användar ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSVARIG_NAMN: {
          AttributeName: 'ANSVARIG_NAMN',
          DisplayLabel: 'Ansvarig',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAArbUnd: {
      CollectionName: 'GAArbUnd',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbUnd',
        Abstract: false,
        SOLabel: 'Arbetsunderlag',
        SOGLabel: 'Arbetsunderlag',
        SBLabel: 'Arbetsunderlaget',
        SBGLabel: 'Arbetsunderlaget',
        POLabel: 'Arbetsunderlag',
        POGLabel: 'Arbetsunderlag',
        PBLabel: 'Arbetsunderlagen',
        PBGLabel: 'Arbetsunderlagen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetsunderlaget primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetsunderlaget versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetsunderlaget id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetsunderlaget fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NUMMER: {
          AttributeName: 'NUMMER',
          DisplayLabel: 'Arbetsunderlagsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Utskriven/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['UTSKRIVEN', 'Utskriven'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['UTSKRIVEN', 'U'], ['BACKAD', 'B']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;UTSKRIVEN=Utskriven;BACKAD=Backad"',
          InterfaceType: 'ifChecklist',
        },
        DISTRIKT_ID: {
          AttributeName: 'DISTRIKT_ID',
          DisplayLabel: 'Distrikt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM_SKAPAD: {
          AttributeName: 'DATUM_SKAPAD',
          DisplayLabel: 'Skapat datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN_SKAPAD: {
          AttributeName: 'SIGN_SKAPAD',
          DisplayLabel: 'Skapat av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM_UTSKRIVEN: {
          AttributeName: 'DATUM_UTSKRIVEN',
          DisplayLabel: 'Utskrivet datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SIGN_UTSKRIVEN: {
          AttributeName: 'SIGN_UTSKRIVEN',
          DisplayLabel: 'Utskrivet av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM_BACKAD: {
          AttributeName: 'DATUM_BACKAD',
          DisplayLabel: 'Backat datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SIGN_BACKAD: {
          AttributeName: 'SIGN_BACKAD',
          DisplayLabel: 'Backat av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Distrikt: {
          AttributeName: 'Distrikt',
          DisplayLabel: 'Distrikt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        StatusText: {
          AttributeName: 'StatusText',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Skapad: {
          AttributeName: 'Skapad',
          DisplayLabel: 'Skapat',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Utskriven: {
          AttributeName: 'Utskriven',
          DisplayLabel: 'Utskrivet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Backad: {
          AttributeName: 'Backad',
          DisplayLabel: 'Backat',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ArbUndSerieID: {
          AttributeName: 'ArbUndSerieID',
          DisplayLabel: 'Nummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ArbUndDefSerieID: {
          AttributeName: 'ArbUndDefSerieID',
          DisplayLabel: 'Nummerserie default',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAArbUndBlob',
          AssociatedComponentName: 'ArbUndBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Distrikt: {
          AssociationName: 'Distrikt',
          DisplayLabel: 'Distrikt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GADistrikt',
          AssociatedComponentName: 'Distrikt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arsskotsel: {
          AssociationName: 'Arsskotsel',
          DisplayLabel: 'Årsskötsel',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAArbUndSkotsel',
          AssociatedComponentName: 'ArbUndSkotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAArbUndBlob: {
      CollectionName: 'GAArbUndBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbUndBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GAArbUndBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GAArbUndBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'GAArbUndBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GAArbUndBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URVAL: {
          AttributeName: 'URVAL',
          DisplayLabel: 'Urval',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAAvdelning: {
      CollectionName: 'GAAvdelning',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Avdelning',
        Abstract: false,
        SOLabel: 'Avdelning',
        SOGLabel: 'Avdelning',
        SBLabel: 'Avdelningen',
        SBGLabel: 'Avdelningen',
        POLabel: 'Avdelningar',
        POGLabel: 'Avdelningar',
        PBLabel: 'Avdelningarna',
        PBGLabel: 'Avdelningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Avdelningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Avdelningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Avdelningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Avdelningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVDELNING: {
          AttributeName: 'AVDELNING',
          DisplayLabel: 'Avdelning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;'], ['ConditionShowValuesFilter', '{Kvarter.KGard.KGARD} = #../Kvarter/KGard/KGARD# and {Kvarter.KVARTER} = #../Kvarter/KVARTER#']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesFilter', '{Kvarter.KGard.KGARD} = #../Kvarter/KGard/KGARD# and {Kvarter.KVARTER} = #../Kvarter/KVARTER#']]),
        },
        KVARTER_KGARD_ID: {
          AttributeName: 'KVARTER_KGARD_ID',
          DisplayLabel: 'Kyrkogård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SafeBenamning: {
          AttributeName: 'SafeBenamning',
          DisplayLabel: 'Benämning eller kod',
          Hint: 'Visar kod om benämning saknas',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kvarter: {
          AssociationName: 'Kvarter',
          DisplayLabel: 'Kvarter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKvarter',
          AssociatedComponentName: 'Kvarter',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravar: {
          AssociationName: 'Gravar',
          DisplayLabel: 'Gravar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GASkotselKategori: {
      CollectionName: 'GASkotselKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Skotselkategori',
        Abstract: false,
        SOLabel: 'Beställningskategori',
        SOGLabel: 'Skötselkategoris',
        SBLabel: 'Beställningskategorin',
        SBGLabel: 'Beställningskategorins',
        POLabel: 'Beställningskategorier',
        POGLabel: 'Beställningskategoriers',
        PBLabel: 'Beställningskategorierna',
        PBGLabel: 'Beställningskategoriernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Beställningskategorins primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Beställningskategorins versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Beställningskategorins fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        EXTBESKRIVNING: {
          AttributeName: 'EXTBESKRIVNING',
          DisplayLabel: 'Extern beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AntalArtiklar: {
          AttributeName: 'AntalArtiklar',
          DisplayLabel: 'Antal ingående artiklar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.greater,
        },
        AntalGravar: {
          AttributeName: 'AntalGravar',
          DisplayLabel: 'Antal Gravar med denna kategori',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.greater,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        KategoriArtiklar: {
          AssociationName: 'KategoriArtiklar',
          DisplayLabel: 'Artiklar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotselKategoriArtikel',
          AssociatedComponentName: 'SkotselKategoriArtikel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KategoriGravar: {
          AssociationName: 'KategoriGravar',
          DisplayLabel: 'Gravar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'GravplatsAktuell',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravBlob: {
      CollectionName: 'GAGravBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravBlob',
        Abstract: false,
        SOLabel: 'Bild',
        SOGLabel: 'Bilds',
        SBLabel: 'Bilden',
        SBGLabel: 'Bildens',
        POLabel: 'Bilder',
        POGLabel: 'Bilders',
        PBLabel: 'Bilderna',
        PBGLabel: 'Bildernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bildens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bildens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bildens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bildens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAV_ID: {
          AttributeName: 'GRAV_ID',
          DisplayLabel: 'Grav',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          Properties: new Map([['WordAttribute', 'True;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Storlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Stretch',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDANTECKNING: {
          AttributeName: 'BILDANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BILDDATUM: {
          AttributeName: 'BILDDATUM',
          DisplayLabel: 'Bildens datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
        },
        BildFinns: {
          AttributeName: 'BildFinns',
          DisplayLabel: 'Bild finns (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        BILD_ANDRAD: {
          AttributeName: 'BILD_ANDRAD',
          DisplayLabel: 'Bild ändrad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BILD_ANDRAD_SIGN: {
          AttributeName: 'BILD_ANDRAD_SIGN',
          DisplayLabel: 'Bild ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILD_WEBAVENY: {
          AttributeName: 'BILD_WEBAVENY',
          DisplayLabel: 'Bild ändrad i WebAveny',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BildAndrad: {
          AttributeName: 'BildAndrad',
          DisplayLabel: 'Bild ändrad',
          Hint: 'Datum, signatur, WebAveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BildDatum2: {
          AttributeName: 'BildDatum2',
          DisplayLabel: 'Bildens datum',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Bildtyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="B=Huvudbild;A=Anordning;K=Stenkontroll;V=Vanvård;S=Skiss/gravläge;[BLANK]=Bild"',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TypOrder: {
          AttributeName: 'TypOrder',
          DisplayLabel: 'Typordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnordningBorttagen: {
          AttributeName: 'AnordningBorttagen',
          DisplayLabel: 'Borttagen anordning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        kontrollBorttagen: {
          AttributeName: 'kontrollBorttagen',
          DisplayLabel: 'Borttagen anordnings kontroll',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        BILD_BENAMNING: {
          AttributeName: 'BILD_BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PUBLICERINGSDATUM_SVG: {
          AttributeName: 'PUBLICERINGSDATUM_SVG',
          DisplayLabel: 'Publiceringsdatum SvG',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
        },
        PUBLICERAD_SVG: {
          AttributeName: 'PUBLICERAD_SVG',
          DisplayLabel: 'Publicerad SvG',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
      },
      Associations: {
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Anordning: {
          AssociationName: 'Anordning',
          DisplayLabel: 'Anordning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravanordning',
          AssociatedComponentName: 'Gravanordning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontroll: {
          AssociationName: 'Kontroll',
          DisplayLabel: 'Anordning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravKontroll',
          AssociatedComponentName: 'GravKontroll',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravBorttagen: {
      CollectionName: 'GAGravBorttagen',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravBorttagen',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GAGravBorttagens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GAGravBorttagens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GAGravBorttagens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SG_SKICKAD: {
          AttributeName: 'SG_SKICKAD',
          DisplayLabel: 'SG_Skickad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GADistrikt: {
      CollectionName: 'GADistrikt',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Distrikt',
        Abstract: false,
        SOLabel: 'Distrikt',
        SOGLabel: 'Distrikt',
        SBLabel: 'Distriktet',
        SBGLabel: 'Distriktet',
        POLabel: 'Distrikt',
        POGLabel: 'Distrikt',
        PBLabel: 'Distrikten',
        PBGLabel: 'Distrikten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Distriktet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Distriktet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Distriktet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Distriktet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DISTRIKT: {
          AttributeName: 'DISTRIKT',
          DisplayLabel: 'Distrikt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ARBETSUNDERLAG_SERIE_ID: {
          AttributeName: 'ARBETSUNDERLAG_SERIE_ID',
          DisplayLabel: 'Arbetsunderlagsnummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HasKGard: {
          AttributeName: 'HasKGard',
          DisplayLabel: 'Har kyrkogårdar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningKod: {
          AttributeName: 'BenamningKod',
          DisplayLabel: 'Benäming',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ArbetsunderlagSerie: {
          AssociationName: 'ArbetsunderlagSerie',
          DisplayLabel: 'Arbetsunderlagsnummerserie',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KGardar: {
          AssociationName: 'KGardar',
          DisplayLabel: 'Kyrkogårdar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Arbetsunderlag: {
          AssociationName: 'Arbetsunderlag',
          DisplayLabel: 'Arbetsunderlag',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAArbUnd',
          AssociatedComponentName: 'ArbUnd',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravDjup: {
      CollectionName: 'GAGravDjup',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravDjup',
        Abstract: false,
        SOLabel: 'Djup',
        SOGLabel: 'Djup',
        SBLabel: 'Djupet',
        SBGLabel: 'Djupet',
        POLabel: 'Djup',
        POGLabel: 'Djup',
        PBLabel: 'Djupen',
        PBGLabel: 'Djupen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Djupet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Djupet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Djupet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Djupet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MINDJUP: {
          AttributeName: 'MINDJUP',
          DisplayLabel: 'Djup',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="9"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        MAXDJUP: {
          AttributeName: 'MAXDJUP',
          DisplayLabel: 'Djup',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="9"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KISTMALL_ID: {
          AttributeName: 'KISTMALL_ID',
          DisplayLabel: 'Kistmall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URNMALL_ID: {
          AttributeName: 'URNMALL_ID',
          DisplayLabel: 'Urnmall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URNKAMMARE_PLAC: {
          AttributeName: 'URNKAMMARE_PLAC',
          DisplayLabel: 'Urnkammare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DjupCond: {
          AttributeName: 'DjupCond',
          DisplayLabel: 'Djup',
          DataType: 'Int',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        Mall: {
          AttributeName: 'Mall',
          DisplayLabel: 'Mall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MallBenamning: {
          AttributeName: 'MallBenamning',
          DisplayLabel: 'Mall benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Malltyp: {
          AttributeName: 'Malltyp',
          DisplayLabel: 'Malltyp',
          Hint: 'K = ren kistmall, U = ren urnmall, C = kombinationsmall',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Djup: {
          AttributeName: 'Djup',
          DisplayLabel: 'Djup',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MallCond: {
          AttributeName: 'MallCond',
          DisplayLabel: 'Mall, kod',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesSubsystem', 'GA;'], ['ConditionShowValuesCollection', 'TEDGAMallSaml;'], ['ConditionShowValuesAttribute', 'KOD;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Gravplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kistmall: {
          AssociationName: 'Kistmall',
          DisplayLabel: 'Kistmall',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAMall',
          AssociatedComponentName: 'Mall',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Urnmall: {
          AssociationName: 'Urnmall',
          DisplayLabel: 'Urnmall',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAMall',
          AssociatedComponentName: 'Mall',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravActiveX: {
      CollectionName: 'GAGravActiveX',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravActiveX',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          Required: true,
          MaskedValue: true,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Begravningsplats',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAHandelseDodsbo: {
      CollectionName: 'GAHandelseDodsbo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'HandelseDodsbo',
        Abstract: false,
        SOLabel: 'Dödsbo händelse',
        SOGLabel: 'Dödsbo händelses',
        SBLabel: 'Dödsbo händelsen',
        SBGLabel: 'Dödsbo händelsens',
        POLabel: 'Dödsbo händelser',
        POGLabel: 'Dödsbo händelsers',
        PBLabel: 'Dödsbo händelserna',
        PBGLabel: 'Dödsbo händelserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dödsbo händelsens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dödsbo händelsens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dödsbo händelsens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'Händelse',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    GAAvtal: {
      CollectionName: 'GAAvtal',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '32'], ['BLANKETT_GRAVPLATS_BASE', 'Grav']]),
      RootType: {
        TypeValue: 'GammaltAvtal',
        Abstract: false,
        SOLabel: 'Ej skuldfört avtal',
        SOGLabel: 'Ej skuldfört avtal',
        SBLabel: 'avtalet',
        SBGLabel: 'avtalet',
        POLabel: 'Ej skuldförda avtal',
        POGLabel: 'Ej skuldförda avtal',
        PBLabel: 'avtalen',
        PBGLabel: 'avtalen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'avtalet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'avtalet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'avtalet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'avtalet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ av avtal',
          Hint: 'Allframtidsavtal/Ej skuldf. fasttidsavtal',
          DataType: 'Enum',
          EnumValues: new Map([['ALLFRAMTIDSAVTAL', 'Allframtidsavtal'], ['EJ_SKULDF__FASTTIDSAVTAL', 'Ej skuldf. fasttidsavtal']]),
          EnumSortValues: new Map([['ALLFRAMTIDSAVTAL', 'A'], ['EJ_SKULDF__FASTTIDSAVTAL', 'G']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ALLFRAMTIDSAVTAL=Allframtidsavtal;EJ_SKULDF__FASTTIDSAVTAL=Ej skuldf. fasttidsavtal"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        AVTALSNR: {
          AttributeName: 'AVTALSNR',
          DisplayLabel: 'Avtalsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KAPITAL: {
          AttributeName: 'KAPITAL',
          DisplayLabel: 'Insatt kapital',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM_FR: {
          AttributeName: 'DATUM_FR',
          DisplayLabel: 'Datum fr o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM_TI: {
          AttributeName: 'DATUM_TI',
          DisplayLabel: 'Datum t.o.m.',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Datum: {
          AttributeName: 'Datum',
          DisplayLabel: 'Avtalsperiod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Debsatt: {
          AttributeName: 'Debsatt',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DebsattNr: {
          AttributeName: 'DebsattNr',
          DisplayLabel: 'Debiteringssätt och Avtal',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'GravplatsAktuell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Skotslar: {
          AssociationName: 'Skotslar',
          DisplayLabel: 'Skötslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravsattFlyttad: {
      CollectionName: 'GAGravsattFlyttad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravsattFlyttad',
        Abstract: false,
        SOLabel: 'Flyttad gravsatt',
        SOGLabel: 'Flyttad gravsatts',
        SBLabel: 'Flyttade gravsatta',
        SBGLabel: 'Flyttade gravsattas',
        POLabel: 'Flyttade gravsatta',
        POGLabel: 'Flyttade gravsattas',
        PBLabel: 'Flyttade gravsatta',
        PBGLabel: 'Flyttade gravsattas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Flyttade gravsattas primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Flyttade gravsattas versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Flyttade gravsattas id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Flyttade gravsattas fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        P_ID: {
          AttributeName: 'P_ID',
          DisplayLabel: 'Avliden',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          Hint: 'Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NamnFE: {
          AttributeName: 'NamnFE',
          DisplayLabel: 'Namn (förnamn efternamn)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxDate="+0m";MaxRecommendedDate="+0m"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BEGR_DATUM: {
          AttributeName: 'BEGR_DATUM',
          DisplayLabel: 'Begravningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GRAVS_DATUM: {
          AttributeName: 'GRAVS_DATUM',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SortNamnFullst: {
          AttributeName: 'SortNamnFullst',
          DisplayLabel: 'Sortering, Namn, Fullst förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        SortFNamnFullst: {
          AttributeName: 'SortFNamnFullst',
          DisplayLabel: 'Sortering, Fullst förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FLYTTDATUM: {
          AttributeName: 'FLYTTDATUM',
          DisplayLabel: 'Flyttad den',
          Hint: 'Ja/Nej',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avliden: {
          AssociationName: 'Avliden',
          DisplayLabel: 'Avliden',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,Pers_Nr,OP_Namn,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,NamnEFF,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,LKFStatus;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",Pers_Nr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:Person="";'], ['NOT_ATAGANDE', 'Y']]),
        },
      },
    },
    GAGrav: {
      CollectionName: 'GAGrav',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1'], ['BLANKETT_GRAVPLATS_BASE', '.'], ['Utskick', 'Y'], ['AllowEdit', '21001']]),
      RootType: {
        TypeValue: 'Begravningsplats',
        Abstract: true,
        SOLabel: 'Grav/Annan ort',
        SOGLabel: 'Grav/Annan ort',
        SBLabel: 'Grav/Annan ort',
        SBGLabel: 'Grav/Annan ort',
        POLabel: 'Grav/Annan ort',
        POGLabel: 'Grav/Annan ort',
        PBLabel: 'Grav/Annan ort',
        PBGLabel: 'Grav/Annan ort',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Grav',
            Abstract: true,
            SOLabel: 'Grav',
            SOGLabel: 'Grav',
            SBLabel: 'Graven',
            SBGLabel: 'Graven',
            POLabel: 'Gravar',
            POGLabel: 'Gravar',
            PBLabel: 'Gravarna',
            PBGLabel: 'Gravarna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Gravplats',
                Abstract: true,
                SOLabel: 'Gravplats/Gravplatshistorik',
                SOGLabel: 'Gravplats/Gravplatshistorik',
                SBLabel: 'Gravplatsen/Gravplatshistoriken',
                SBGLabel: 'Gravplatsen/Gravplatshistoriken',
                POLabel: 'Gravplatser/Gravplatshistorik',
                POGLabel: 'Gravplatser/Gravplatshistorik',
                PBLabel: 'Gravplatserna/Gravplatshistoriken',
                PBGLabel: 'Gravplatserna/Gravplatshistoriken',
                Visible: true,
                ChildTypes: [
                  {
                    TypeValue: 'GravplatsAktuell',
                    Abstract: false,
                    SOLabel: 'Gravplats',
                    SOGLabel: 'Gravplats',
                    SBLabel: 'Gravplatsen',
                    SBGLabel: 'Gravplatsen',
                    POLabel: 'Gravplatser',
                    POGLabel: 'Gravplatser',
                    PBLabel: 'Gravplatserna',
                    PBGLabel: 'Gravplatserna',
                    Visible: true,
                    ChildTypes: [
                    ],
                  },
                  {
                    TypeValue: 'GravplatsHistorik',
                    Abstract: true,
                    SOLabel: 'Gravplatshistorik',
                    SOGLabel: 'Gravplatshistorik',
                    SBLabel: 'Gravplatshistoriken',
                    SBGLabel: 'Gravplatshistoriken',
                    POLabel: 'Gravplatshistorik',
                    POGLabel: 'Gravplatshistorik',
                    PBLabel: 'Gravplatshistoriken',
                    PBGLabel: 'Gravplatshistoriken',
                    Visible: true,
                    ChildTypes: [
                      {
                        TypeValue: 'GravplatsAterlamnad',
                        Abstract: false,
                        SOLabel: 'Återlämnad gravplats',
                        SOGLabel: 'Återlämnad gravplats',
                        SBLabel: 'Återlämnade gravplatsen',
                        SBGLabel: 'Återlämnade gravplatsen',
                        POLabel: 'Återlämnade gravplatser',
                        POGLabel: 'Återlämnade gravplatser',
                        PBLabel: 'Återlämnade gravplatserna',
                        PBGLabel: 'Återlämnade gravplatserna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                      {
                        TypeValue: 'GravplatsAtertagen',
                        Abstract: false,
                        SOLabel: 'Återtagen gravplats',
                        SOGLabel: 'Återtagen gravplats',
                        SBLabel: 'Återtagna gravplatsen',
                        SBGLabel: 'Återtagna gravplatsen',
                        POLabel: 'Återtagna gravplatser',
                        POGLabel: 'Återtagna gravplatser',
                        PBLabel: 'Återtagna gravplatserna',
                        PBGLabel: 'Återtagna gravplatserna',
                        Visible: true,
                        ChildTypes: [
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                TypeValue: 'Minneslund',
                Abstract: false,
                SOLabel: 'Minneslund',
                SOGLabel: 'Minneslund',
                SBLabel: 'Minneslunden',
                SBGLabel: 'Minneslunden',
                POLabel: 'Minneslundar',
                POGLabel: 'Minneslundar',
                PBLabel: 'Minneslundarna',
                PBGLabel: 'Minneslundarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Askgravlund',
                Abstract: false,
                SOLabel: 'Askgravlund',
                SOGLabel: 'Askgravlunds',
                SBLabel: 'Askgravlunden',
                SBGLabel: 'Askgravlundens',
                POLabel: 'Askgravlundar',
                POGLabel: 'Askgravlundars',
                PBLabel: 'Askgravlundarna',
                PBGLabel: 'Askgravlundarnas',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'AnnanOrt',
            Abstract: false,
            SOLabel: 'Annan ort',
            SOGLabel: 'Annan ort',
            SBLabel: 'Annan ort',
            SBGLabel: 'Annan ort',
            POLabel: 'Annan ort',
            POGLabel: 'Annan ort',
            PBLabel: 'Annan ort',
            PBGLabel: 'Annan ort',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Grav/Annan ort primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Grav/Annan ort versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Gravplatstyp',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVPLATSAKTUELL', 'Gravplats'], ['GRAVPLATSATERLAMNAD', 'Återlämnad gravplats'], ['GRAVPLATSATERTAGEN', 'Återtagen gravplats'], ['MINNESLUND', 'Minneslund'], ['ASKGRAVLUND', 'Askgravlund'], ['ANNANORT', 'Annan ort']]),
          EnumSortValues: new Map([['GRAVPLATSAKTUELL', 'G'], ['GRAVPLATSATERLAMNAD', 'A'], ['GRAVPLATSATERTAGEN', 'T'], ['MINNESLUND', 'M'], ['ASKGRAVLUND', 'S'], ['ANNANORT', 'O']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAVPLATSAKTUELL=Gravplats;GRAVPLATSATERLAMNAD=Återlämnad gravplats;GRAVPLATSATERTAGEN=Återtagen gravplats;MINNESLUND=Minneslund;ASKGRAVLUND=Askgravlund;ANNANORT=Annan ort"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Grav/Annan ort id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Grav/Annan ort fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVPLATS_ID: {
          AttributeName: 'GRAVPLATS_ID',
          DisplayLabel: 'Gravplats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KVARTER_KGARD_ID: {
          AttributeName: 'KVARTER_KGARD_ID',
          DisplayLabel: 'Kyrkogård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
        },
        GRAVNUMMER: {
          AttributeName: 'GRAVNUMMER',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Gravplatsnummer',
          Required: true,
        },
        GRAVNUMMER_FULLT: {
          AttributeName: 'GRAVNUMMER_FULLT',
          DisplayLabel: 'Gravplatsnummer, fullt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        GRAVNUMMER_NUMERISKT: {
          AttributeName: 'GRAVNUMMER_NUMERISKT',
          DisplayLabel: 'Gravnummer, numeriskt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.equals, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Gravplatsnummer',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ANTECKNINGAR: {
          AttributeName: 'ANTECKNINGAR',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ANDRINGSDATUM: {
          AttributeName: 'ANDRINGSDATUM',
          DisplayLabel: 'Senast ändrad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ATERLAMNAD: {
          AttributeName: 'ATERLAMNAD',
          DisplayLabel: 'Återlämnad/återtagen datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['GravplatsHistorik'],
        },
        GRAVRATT_FR: {
          AttributeName: 'GRAVRATT_FR',
          DisplayLabel: 'Gravrätt fr o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=60',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          ValidInComps: ['Gravplats'],
        },
        GRAVRATT_TI: {
          AttributeName: 'GRAVRATT_TI',
          DisplayLabel: 'Gravrätt t o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=60',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          ValidInComps: ['Gravplats'],
        },
        KANNETECKEN: {
          AttributeName: 'KANNETECKEN',
          DisplayLabel: 'Kännetecken',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Gravplats'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        MALL_ID: {
          AttributeName: 'MALL_ID',
          DisplayLabel: 'Mall',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        SLEK_B: {
          AttributeName: 'SLEK_B',
          DisplayLabel: 'Storlek, Bredd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Gravplats'],
        },
        SLEK_L: {
          AttributeName: 'SLEK_L',
          DisplayLabel: 'Storlek, Längd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Gravplats'],
        },
        UPL_OMG: {
          AttributeName: 'UPL_OMG',
          DisplayLabel: 'Upplåtelseomgång',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Gravplats'],
          AttributeGroup: 'Gravplatsnummer',
        },
        UPL_STATUS: {
          AttributeName: 'UPL_STATUS',
          DisplayLabel: 'Upplåtelsestatus',
          Hint: 'Upplåten/Ej upplåten/Kan ej upplåtas/Finns ej mer/Begränsad gravrätt',
          DataType: 'Enum',
          EnumValues: new Map([['UPPLATEN', 'Upplåten'], ['EJ_UPPLATEN', 'Ej upplåten'], ['KAN_EJ_UPPLATAS', 'Kan ej upplåtas'], ['FINNS_EJ_MER', 'Finns ej mer'], ['BEGRANSAD_GRAVRATT', 'Begränsad gravrätt']]),
          EnumSortValues: new Map([['UPPLATEN', 'U'], ['EJ_UPPLATEN', 'D'], ['KAN_EJ_UPPLATAS', 'E'], ['FINNS_EJ_MER', 'F'], ['BEGRANSAD_GRAVRATT', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UPPLATEN=Upplåten;EJ_UPPLATEN=Ej upplåten;KAN_EJ_UPPLATAS=Kan ej upplåtas;FINNS_EJ_MER=Finns ej mer;BEGRANSAD_GRAVRATT=Begränsad gravrätt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['GravplatsAktuell'],
        },
        GravNr: {
          AttributeName: 'GravNr',
          DisplayLabel: 'Gravplatsnummer',
          Hint: 'Fullständigt gravplatsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Gravplatsnummer',
        },
        GravNrOrder: {
          AttributeName: 'GravNrOrder',
          DisplayLabel: 'Gravplatsnummer sorteringsordning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Gravplatsnummer',
        },
        Gravratt: {
          AttributeName: 'Gravratt',
          DisplayLabel: 'Gravrätt',
          Hint: 'Gravrättstid, fråntid och tilltid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        GravTyp: {
          AttributeName: 'GravTyp',
          DisplayLabel: 'Gravtyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kvarter: {
          AttributeName: 'Kvarter',
          DisplayLabel: 'Benämning kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Grav'],
          AttributeGroup: 'Gravplatsnummer',
          Properties: new Map([['NO_CONDITION', 'True']]),
        },
        KvarterKod: {
          AttributeName: 'KvarterKod',
          DisplayLabel: 'Kod kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Grav'],
          AttributeGroup: 'Gravplatsnummer',
        },
        Storlek: {
          AttributeName: 'Storlek',
          DisplayLabel: 'Storlek, Längd och bredd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        Yta: {
          AttributeName: 'Yta',
          DisplayLabel: 'Storlek, Yta',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Gravplats'],
        },
        AktuellGravID: {
          AttributeName: 'AktuellGravID',
          DisplayLabel: 'Aktuell gravplats, ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktuellGravStatus: {
          AttributeName: 'AktuellGravStatus',
          DisplayLabel: 'Aktuell gravplats, Upplåtelsestatus',
          Hint: 'Upplåten/Ej upplåten/Kan ej upplåtas/Finns ej mer',
          DataType: 'Enum',
          EnumValues: new Map([['UPPLATEN', 'Upplåten'], ['EJ_UPPLATEN', 'Ej upplåten'], ['KAN_EJ_UPPLATAS', 'Kan ej upplåtas'], ['FINNS_EJ_MER', 'Finns ej mer']]),
          EnumSortValues: new Map([['UPPLATEN', 'U'], ['EJ_UPPLATEN', 'D'], ['KAN_EJ_UPPLATAS', 'E'], ['FINNS_EJ_MER', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UPPLATEN=Upplåten;EJ_UPPLATEN=Ej upplåten;KAN_EJ_UPPLATAS=Kan ej upplåtas;FINNS_EJ_MER=Finns ej mer"',
          ValidInComps: ['Gravplats'],
        },
        SenastAter: {
          AttributeName: 'SenastAter',
          DisplayLabel: 'Senast återlämnad/återtagen',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GravplatsAktuell'],
        },
        TidigareUplOmg: {
          AttributeName: 'TidigareUplOmg',
          DisplayLabel: 'Antal tidigare uppl.omg',
          Hint: 'Antal tidigare upplåtelseomgångar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Gravplats'],
        },
        GravrInhLopnr: {
          AttributeName: 'GravrInhLopnr',
          DisplayLabel: 'Gravrättsinnehavare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        GravrInhNamnTyp: {
          AttributeName: 'GravrInhNamnTyp',
          DisplayLabel: 'Gravrättsinnehavare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SenastGSLopnr: {
          AttributeName: 'SenastGSLopnr',
          DisplayLabel: 'Senast gravsatt, löpnummer',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        SenastGSDjup: {
          AttributeName: 'SenastGSDjup',
          DisplayLabel: 'Senast gravsatt, djup',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          ValidInComps: ['Gravplats'],
        },
        SenastGSGravsDatum: {
          AttributeName: 'SenastGSGravsDatum',
          DisplayLabel: 'Senast gravsatt, gravsättningsdatum',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          ValidInComps: ['Gravplats'],
        },
        SenastGSNamn: {
          AttributeName: 'SenastGSNamn',
          DisplayLabel: 'Senast gravsatt, namn',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SenastGSNamnFE: {
          AttributeName: 'SenastGSNamnFE',
          DisplayLabel: 'Senast gravsatt, namn (förnamn efternamn)',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SenastGSPersNr: {
          AttributeName: 'SenastGSPersNr',
          DisplayLabel: 'Senast gravsatt, personnummer',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatPersNr',
          ValidInComps: ['Gravplats'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SenastGSPlac: {
          AttributeName: 'SenastGSPlac',
          DisplayLabel: 'Senast gravsatt, placering',
          Hint: 'Gäller alla upplåtelseomgångar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        StatusBen: {
          AttributeName: 'StatusBen',
          DisplayLabel: 'Status benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Grav'],
          Properties: new Map([['NO_CONDITION', 'True']]),
        },
        StatusKod: {
          AttributeName: 'StatusKod',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Grav'],
        },
        SenastAterTyp: {
          AttributeName: 'SenastAterTyp',
          DisplayLabel: 'Senast återlämnad eller återtagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['Gravplats'],
        },
        GravrattPubl: {
          AttributeName: 'GravrattPubl',
          DisplayLabel: 'Gravrätt, publicerad',
          Hint: 'Gravrättstid, fråntid och tilltid eller texten "för all framtid", eller texten "Gravrätten har återgått"',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        HandelseFinns: {
          AttributeName: 'HandelseFinns',
          DisplayLabel: 'Har pågående händelser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        SenastGSLopnr2: {
          AttributeName: 'SenastGSLopnr2',
          DisplayLabel: 'Senast gravsatt, löpnummer',
          Hint: 'Gäller aktuell upplåtelseomgång',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gravplats'],
        },
        GravNrPublic: {
          AttributeName: 'GravNrPublic',
          DisplayLabel: 'Gravplatsnummer, publikt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Gravplatsnummer',
        },
        GravNrPublicSort: {
          AttributeName: 'GravNrPublicSort',
          DisplayLabel: 'Gravplatsnummer, publikt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
        },
        ANYTA_ID: {
          AttributeName: 'ANYTA_ID',
          DisplayLabel: 'Yta',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANKULTUR_ID: {
          AttributeName: 'ANKULTUR_ID',
          DisplayLabel: 'Kultur',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VanvardMarkering: {
          AttributeName: 'VanvardMarkering',
          DisplayLabel: 'Senaste vanvårdsmarkering',
          Hint: 'Vanvård 1/Vanvård 2/Vanvård 3/Gravrätten Förverkad/Godkänd',
          DataType: 'Enum',
          EnumValues: new Map([['VANVARD_1', 'Vanvård 1'], ['VANVARD_2', 'Vanvård 2'], ['VANVARD_3', 'Vanvård 3'], ['GRAVRATTEN_FORVERKAD', 'Gravrätten Förverkad'], ['GODKAND', 'Godkänd']]),
          EnumSortValues: new Map([['VANVARD_1', '1'], ['VANVARD_2', '2'], ['VANVARD_3', '3'], ['GRAVRATTEN_FORVERKAD', 'F'], ['GODKAND', 'G']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VANVARD_1=Vanvård 1;VANVARD_2=Vanvård 2;VANVARD_3=Vanvård 3;GRAVRATTEN_FORVERKAD=Gravrätten Förverkad;GODKAND=Godkänd"',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        Besiktningsdatum: {
          AttributeName: 'Besiktningsdatum',
          DisplayLabel: 'Senaste besiktningsdatum, Vanvård',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKOTSELKATEGORIID: {
          AttributeName: 'SKOTSELKATEGORIID',
          DisplayLabel: 'SkötselkategoriID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANKULTURNOTERING: {
          AttributeName: 'ANKULTURNOTERING',
          DisplayLabel: 'Kulturnotering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        anyta: {
          AttributeName: 'anyta',
          DisplayLabel: 'Ytbeläggning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SenastStenStatus: {
          AttributeName: 'SenastStenStatus',
          DisplayLabel: 'Senaste inventering',
          Hint: 'Godkänd/Stöttad/Nedlagd/Ej åtgärdad/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['GODKAND', 'Godkänd'], ['STOTTAD', 'Stöttad'], ['NEDLAGD', 'Nedlagd'], ['EJ_ATGARDAD', 'Ej åtgärdad'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['GODKAND', 'G'], ['STOTTAD', 'S'], ['NEDLAGD', 'N'], ['EJ_ATGARDAD', 'E'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GODKAND=Godkänd;STOTTAD=Stöttad;NEDLAGD=Nedlagd;EJ_ATGARDAD=Ej åtgärdad;OVRIGT=Övrigt"',
        },
        StenDatum: {
          AttributeName: 'StenDatum',
          DisplayLabel: 'Senaste inventering datum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        SenastStenDatum: {
          AttributeName: 'SenastStenDatum',
          DisplayLabel: 'Senaste inventering datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        HandelseFinns2: {
          AttributeName: 'HandelseFinns2',
          DisplayLabel: 'Har pågående händelser',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BOKAD: {
          AttributeName: 'BOKAD',
          DisplayLabel: 'Bokad gravplats',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKAD_DATUM: {
          AttributeName: 'BOKAD_DATUM',
          DisplayLabel: 'Bokad grav datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BOKAD_SIGNATUR: {
          AttributeName: 'BOKAD_SIGNATUR',
          DisplayLabel: 'Bokad, signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VanvardNotering: {
          AttributeName: 'VanvardNotering',
          DisplayLabel: 'Senaste vanvårdsnotering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        VanvardBild: {
          AttributeName: 'VanvardBild',
          DisplayLabel: 'Senaste vanvårdsbild',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MALL_ANMARKNING: {
          AttributeName: 'MALL_ANMARKNING',
          DisplayLabel: 'Mall anmärkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BILD_ID: {
          AttributeName: 'BILD_ID',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravrattForlangningDatum: {
          AttributeName: 'GravrattForlangningDatum',
          DisplayLabel: 'Datum för förlängning av gravrätt',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Förlängning av gravrätt',
        },
        GravrattForlangningAr: {
          AttributeName: 'GravrattForlangningAr',
          DisplayLabel: 'Antal år för förlängning av gravrätt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Förlängning av gravrätt',
        },
        SEKRETESSMARKERAD: {
          AttributeName: 'SEKRETESSMARKERAD',
          DisplayLabel: 'Tillfällig spärr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="L=Tillfälligt spärrad"',
          GUIEditable: true,
          MaxInputLength: 1,
          AttributeGroup: 'Dolda uppgifter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        MaskValuesAvliden: {
          AttributeName: 'MaskValuesAvliden',
          DisplayLabel: 'Dolda uppgifter (person)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifFilter',
          AttributeGroup: 'Dolda uppgifter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        MaskTypeAvliden: {
          AttributeName: 'MaskTypeAvliden',
          DisplayLabel: 'Sekretessmarkerad av Skatteverket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="S=Sekretess;P=Skyddad"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Dolda uppgifter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LopNrVanvard: {
          AttributeName: 'LopNrVanvard',
          DisplayLabel: 'Löpnummer senaste vanvård besiktningsdatum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VANVARD_ARENDE_STATUS: {
          AttributeName: 'VANVARD_ARENDE_STATUS',
          DisplayLabel: 'Ärende status från Hantera vanvård',
          Hint: 'Ej påbörjad/Inväntar svar/Överskriden tid/Utred/Godkänd/Slutförd/Skötsel beställd och betalt/Delgivningsdatum saknas/Förverkad pga vanvård/Återlämnar gravplats/Överklagad/Ej Överklagad/Övrigt (slutförd)/Inväntar delgivningsdatum/Gått över till annan rutin/Efter besiktning godkänd',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_PABORJAD', 'Ej påbörjad'], ['INVANTAR_SVAR', 'Inväntar svar'], ['OVERSKRIDEN_TID', 'Överskriden tid'], ['UTRED', 'Utred'], ['GODKAND', 'Godkänd'], ['SLUTFORD', 'Slutförd'], ['SKOTSEL_BESTALLD_OCH_BETALT', 'Skötsel beställd och betalt'], ['DELGIVNINGSDATUM_SAKNAS', 'Delgivningsdatum saknas'], ['FORVERKAD_PGA_VANVARD', 'Förverkad pga vanvård'], ['ATERLAMNAR_GRAVPLATS', 'Återlämnar gravplats'], ['OVERKLAGAD', 'Överklagad'], ['EJ_OVERKLAGAD', 'Ej Överklagad'], ['OVRIGT__SLUTFORD_', 'Övrigt (slutförd)'], ['INVANTAR_DELGIVNINGSDATUM', 'Inväntar delgivningsdatum'], ['GATT_OVER_TILL_ANNAN_RUTIN', 'Gått över till annan rutin'], ['EFTER_BESIKTNING_GODKAND', 'Efter besiktning godkänd']]),
          EnumSortValues: new Map([['EJ_PABORJAD', 'E'], ['INVANTAR_SVAR', 'I'], ['OVERSKRIDEN_TID', 'T'], ['UTRED', 'U'], ['GODKAND', 'G'], ['SLUTFORD', 'S'], ['SKOTSEL_BESTALLD_OCH_BETALT', 'B'], ['DELGIVNINGSDATUM_SAKNAS', 'D'], ['FORVERKAD_PGA_VANVARD', 'F'], ['ATERLAMNAR_GRAVPLATS', 'A'], ['OVERKLAGAD', 'O'], ['EJ_OVERKLAGAD', 'X'], ['OVRIGT__SLUTFORD_', 'V'], ['INVANTAR_DELGIVNINGSDATUM', 'M'], ['GATT_OVER_TILL_ANNAN_RUTIN', 'R'], ['EFTER_BESIKTNING_GODKAND', 'L']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_PABORJAD=Ej påbörjad;INVANTAR_SVAR=Inväntar svar;OVERSKRIDEN_TID=Överskriden tid;UTRED=Utred;GODKAND=Godkänd;SLUTFORD=Slutförd;SKOTSEL_BESTALLD_OCH_BETALT=Skötsel beställd och betalt;DELGIVNINGSDATUM_SAKNAS=Delgivningsdatum saknas;FORVERKAD_PGA_VANVARD=Förverkad pga vanvård;ATERLAMNAR_GRAVPLATS=Återlämnar gravplats;OVERKLAGAD=Överklagad;EJ_OVERKLAGAD=Ej Överklagad;OVRIGT__SLUTFORD_=Övrigt (slutförd);INVANTAR_DELGIVNINGSDATUM=Inväntar delgivningsdatum;GATT_OVER_TILL_ANNAN_RUTIN=Gått över till annan rutin;EFTER_BESIKTNING_GODKAND=Efter besiktning godkänd"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        VANVARD_PROCESS_STATUS: {
          AttributeName: 'VANVARD_PROCESS_STATUS',
          DisplayLabel: 'Process status från Hantera vanvård',
          Hint: 'Ej skickad meddelande angående vård/Skickad meddelande angående vård/Ej skickad föreläggande/Skickad föreläggande/Ej skickad förverkad/Skickad förverkad/Inväntar åtgärd/Godkänd/Påminnelse/Skickad påminnelse/Slutförd',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_SKICKAD_MEDDELANDE_ANGAENDE_VARD', 'Ej skickad meddelande angående vård'], ['SKICKAD_MEDDELANDE_ANGAENDE_VARD', 'Skickad meddelande angående vård'], ['EJ_SKICKAD_FORELAGGANDE', 'Ej skickad föreläggande'], ['SKICKAD_FORELAGGANDE', 'Skickad föreläggande'], ['EJ_SKICKAD_FORVERKAD', 'Ej skickad förverkad'], ['SKICKAD_FORVERKAD', 'Skickad förverkad'], ['INVANTAR_ATGARD', 'Inväntar åtgärd'], ['GODKAND', 'Godkänd'], ['PAMINNELSE', 'Påminnelse'], ['SKICKAD_PAMINNELSE', 'Skickad påminnelse'], ['SLUTFORD', 'Slutförd']]),
          EnumSortValues: new Map([['EJ_SKICKAD_MEDDELANDE_ANGAENDE_VARD', 'A'], ['SKICKAD_MEDDELANDE_ANGAENDE_VARD', 'B'], ['EJ_SKICKAD_FORELAGGANDE', 'C'], ['SKICKAD_FORELAGGANDE', 'D'], ['EJ_SKICKAD_FORVERKAD', 'E'], ['SKICKAD_FORVERKAD', 'F'], ['INVANTAR_ATGARD', 'I'], ['GODKAND', 'G'], ['PAMINNELSE', 'P'], ['SKICKAD_PAMINNELSE', 'Q'], ['SLUTFORD', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_SKICKAD_MEDDELANDE_ANGAENDE_VARD=Ej skickad meddelande angående vård;SKICKAD_MEDDELANDE_ANGAENDE_VARD=Skickad meddelande angående vård;EJ_SKICKAD_FORELAGGANDE=Ej skickad föreläggande;SKICKAD_FORELAGGANDE=Skickad föreläggande;EJ_SKICKAD_FORVERKAD=Ej skickad förverkad;SKICKAD_FORVERKAD=Skickad förverkad;INVANTAR_ATGARD=Inväntar åtgärd;GODKAND=Godkänd;PAMINNELSE=Påminnelse;SKICKAD_PAMINNELSE=Skickad påminnelse;SLUTFORD=Slutförd"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
      },
      Associations: {
        KGard: {
          AssociationName: 'KGard',
          DisplayLabel: 'Kyrkogård',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kvarter: {
          AssociationName: 'Kvarter',
          DisplayLabel: 'Kyrkogård och kvarter',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKvarter',
          AssociatedComponentName: 'Kvarter',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Kvarter, benämning",SafeBenamning="Kvarter, benämning eller kod",KodBenamning="Kvarter, kod och benämning",G:*="Gravplatsnummer"']]),
        },
        Avdelning: {
          AssociationName: 'Avdelning',
          DisplayLabel: 'Avdelning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAAvdelning',
          AssociatedComponentName: 'Avdelning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Avdelning, benämning",SafeBenamning="Avdelning, benämning eller kod",KodBenamning="Avdelning, kod och benämning",G:*="Gravplatsnummer"']]),
        },
        Mall: {
          AssociationName: 'Mall',
          DisplayLabel: 'Mall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAMall',
          AssociatedComponentName: 'Mall',
          JoinAssociation: true,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GravrInhOmbud: {
          AssociationName: 'GravrInhOmbud',
          DisplayLabel: 'Senaste gravrättsinnehavare/ombud',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Gravrattsinnehavare',
          JoinAssociation: true,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktuellGrav: {
          AssociationName: 'AktuellGrav',
          DisplayLabel: 'Aktuell upplåtelseomgång',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'GravplatsAktuell',
          JoinAssociation: true,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SenastGS: {
          AssociationName: 'SenastGS',
          DisplayLabel: 'Senast gravsatt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravsatt',
          AssociatedComponentName: 'Gravsatt',
          JoinAssociation: true,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AnordningYta: {
          AssociationName: 'AnordningYta',
          DisplayLabel: 'Ytbeläggning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravYta',
          AssociatedComponentName: 'GravYta',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AnordningKultur: {
          AssociationName: 'AnordningKultur',
          DisplayLabel: 'Kultur/Bevarandevärde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravKultur',
          AssociatedComponentName: 'GravKultur',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SkotselKategori: {
          AssociationName: 'SkotselKategori',
          DisplayLabel: 'Beställningskategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotselKategori',
          AssociatedComponentName: 'Skotselkategori',
          JoinAssociation: true,
          ValidInComps: ['GravplatsAktuell'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Bild',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravBlob',
          AssociatedComponentName: 'GravBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        VanvardHantering: {
          AssociationName: 'VanvardHantering',
          DisplayLabel: 'Vanvård',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAVanvard',
          AssociatedComponentName: 'Vanvard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravsatta: {
          AssociationName: 'Gravsatta',
          DisplayLabel: 'Gravsatta',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravsatt',
          AssociatedComponentName: 'Gravsatt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        GravsattaFlyttade: {
          AssociationName: 'GravsattaFlyttade',
          DisplayLabel: 'Gravsatta, flyttade',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravsattFlyttad',
          AssociatedComponentName: 'GravsattFlyttad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravActiveX',
          AssociatedComponentName: 'GravActiveX',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Statuskoder: {
          AssociationName: 'Statuskoder',
          DisplayLabel: 'Statuskoder',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravGravStatus',
          AssociatedComponentName: 'GravGravStatus',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontakter: {
          AssociationName: 'Kontakter',
          DisplayLabel: 'Kontakter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        BetAnsv: {
          AssociationName: 'BetAnsv',
          DisplayLabel: 'Betalningsansvariga',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Betalningsansvarig',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GravrInh: {
          AssociationName: 'GravrInh',
          DisplayLabel: 'Gravrättsinnehavare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Gravrattsinnehavare',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        OvrKontakter: {
          AssociationName: 'OvrKontakter',
          DisplayLabel: 'Övriga kontakter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'KontaktOvrig',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avtal: {
          AssociationName: 'Avtal',
          DisplayLabel: 'Ej skuldförda avtal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAAvtal',
          AssociatedComponentName: 'GammaltAvtal',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Skotslar: {
          AssociationName: 'Skotslar',
          DisplayLabel: 'Skötslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Djup: {
          AssociationName: 'Djup',
          DisplayLabel: 'Djup',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravDjup',
          AssociatedComponentName: 'GravDjup',
          JoinAssociation: false,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        GRIHistorik: {
          AssociationName: 'GRIHistorik',
          DisplayLabel: 'Gravrättsinnehavare historik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGRIHistorik',
          AssociatedComponentName: 'GRIHistorik',
          JoinAssociation: false,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        GravrattHist: {
          AssociationName: 'GravrattHist',
          DisplayLabel: 'Gravrättshistorik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravrattHist',
          AssociatedComponentName: 'GravrattHist',
          JoinAssociation: false,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        UplOmg: {
          AssociationName: 'UplOmg',
          DisplayLabel: 'Upplåtelseomgångar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Gravplats',
          JoinAssociation: false,
          ValidInComps: ['Gravplats'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelser: {
          AssociationName: 'Handelser',
          DisplayLabel: 'Händelser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Vanvard: {
          AssociationName: 'Vanvard',
          DisplayLabel: 'Vanvård',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAVanvard',
          AssociatedComponentName: 'Vanvard',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anordningar: {
          AssociationName: 'Anordningar',
          DisplayLabel: 'Gravanordningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravanordning',
          AssociatedComponentName: 'Gravanordning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        GiltigaSkotslar: {
          AssociationName: 'GiltigaSkotslar',
          DisplayLabel: 'Giltiga skötslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: ['Grav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.GRAV_ID} = {FromAlias.ID} and isnull({Alias.AR_TI},9999) >= datepart(yy,getdate()) and isnull({Alias.AR_TI},9999) >= isnull({Alias.AR_FR},0)']]),
        },
        Bilder: {
          AssociationName: 'Bilder',
          DisplayLabel: 'Bilder',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravBlob',
          AssociatedComponentName: 'GravBlob',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dodsbo: {
          AssociationName: 'Dodsbo',
          DisplayLabel: 'Dödsbo',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Dodsbo',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravanordning: {
      CollectionName: 'GAGravanordning',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '44'], ['BLANKETT_GRAVPLATS_BASE', 'Begravningsplats']]),
      RootType: {
        TypeValue: 'Gravanordning',
        Abstract: false,
        SOLabel: 'Gravanordning',
        SOGLabel: 'Gravanordnings',
        SBLabel: 'Gravanordningen',
        SBGLabel: 'Gravanordningens',
        POLabel: 'Gravanordningar',
        POGLabel: 'Gravanordningars',
        PBLabel: 'Gravanordningarna',
        PBGLabel: 'Gravanordningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gravanordningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gravanordningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gravanordningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MATERIAL_ID: {
          AttributeName: 'MATERIAL_ID',
          DisplayLabel: 'Material Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANHOJD: {
          AttributeName: 'ANHOJD',
          DisplayLabel: 'Höjd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'Decimals="2";ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="9"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANBESKRIVNING: {
          AttributeName: 'ANBESKRIVNING',
          DisplayLabel: 'Beskrivning av gravanordning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANDATUM: {
          AttributeName: 'ANDATUM',
          DisplayLabel: 'Ansökan godkänd',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANNAMN: {
          AttributeName: 'ANNAMN',
          DisplayLabel: 'Namn på ansökande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ANBESLUT: {
          AttributeName: 'ANBESLUT',
          DisplayLabel: 'Beslut om anordning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANBENAMNING: {
          AttributeName: 'ANBENAMNING',
          DisplayLabel: 'Anordning benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANNR: {
          AttributeName: 'ANNR',
          DisplayLabel: 'Anordning nr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        anmaterial: {
          AttributeName: 'anmaterial',
          DisplayLabel: 'Gravanordning material',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        STENHUGGERI_ID: {
          AttributeName: 'STENHUGGERI_ID',
          DisplayLabel: 'Id, stenhuggeri',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        StenStatus: {
          AttributeName: 'StenStatus',
          DisplayLabel: 'Senaste inventering',
          Hint: 'Godkänd/Ej godkänd',
          DataType: 'Enum',
          EnumValues: new Map([['GODKAND', 'Godkänd'], ['EJ_GODKAND', 'Ej godkänd']]),
          EnumSortValues: new Map([['GODKAND', 'G'], ['EJ_GODKAND', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GODKAND=Godkänd;EJ_GODKAND=Ej godkänd"',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        StenDatum: {
          AttributeName: 'StenDatum',
          DisplayLabel: 'Senaste inventering datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ANBREDD: {
          AttributeName: 'ANBREDD',
          DisplayLabel: 'Bredd',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="9"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTJOCKLEK: {
          AttributeName: 'ANTJOCKLEK',
          DisplayLabel: 'Tjocklek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="9"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        StenhuggeriBen: {
          AttributeName: 'StenhuggeriBen',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StenSign: {
          AttributeName: 'StenSign',
          DisplayLabel: 'Senaste inventering signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        SenasteStenStatus: {
          AttributeName: 'SenasteStenStatus',
          DisplayLabel: 'Senaste stenstatus',
          Hint: 'Godkänd/Stöttad/Nedlagd/Ej åtgärdad/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['GODKAND', 'Godkänd'], ['STOTTAD', 'Stöttad'], ['NEDLAGD', 'Nedlagd'], ['EJ_ATGARDAD', 'Ej åtgärdad'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['GODKAND', 'G'], ['STOTTAD', 'S'], ['NEDLAGD', 'N'], ['EJ_ATGARDAD', 'E'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GODKAND=Godkänd;STOTTAD=Stöttad;NEDLAGD=Nedlagd;EJ_ATGARDAD=Ej åtgärdad;OVRIGT=Övrigt"',
          InterfaceType: 'ifChecklist',
        },
        SenastStenID: {
          AttributeName: 'SenastStenID',
          DisplayLabel: 'SenastStenID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD_ID: {
          AttributeName: 'BILD_ID',
          DisplayLabel: 'Bild',
          Hint: 'Ja/Nej',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AnordningMaterial: {
          AssociationName: 'AnordningMaterial',
          DisplayLabel: 'Material',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravMaterial',
          AssociatedComponentName: 'GravMaterial',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Stenhuggeri: {
          AssociationName: 'Stenhuggeri',
          DisplayLabel: 'Stenhuggeri',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SenasteKontroll: {
          AssociationName: 'SenasteKontroll',
          DisplayLabel: 'Senaste Kontroll',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravKontroll',
          AssociatedComponentName: 'Gravkontroll',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bild: {
          AssociationName: 'Bild',
          DisplayLabel: 'Bild',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravBlob',
          AssociatedComponentName: 'GravBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Stenkontroll: {
          AssociationName: 'Stenkontroll',
          DisplayLabel: 'Stenkontroll',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravKontroll',
          AssociatedComponentName: 'Gravkontroll',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravList: {
      CollectionName: 'GAGravList',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'GravList',
        Abstract: false,
        SOLabel: 'Gravlista',
        SOGLabel: 'Gravlista',
        SBLabel: 'Gravlistan',
        SBGLabel: 'Gravlistan',
        POLabel: 'Gravlistor',
        POGLabel: 'Gravlistor',
        PBLabel: 'Gravlistorna',
        PBGLabel: 'Gravlistorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gravlistan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gravlistan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gravlistan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gravlistan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Gravplatsstatistik/Gravsättningsstatistik',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVPLATSSTATISTIK', 'Gravplatsstatistik'], ['GRAVSATTNINGSSTATISTIK', 'Gravsättningsstatistik']]),
          EnumSortValues: new Map([['GRAVPLATSSTATISTIK', 'G'], ['GRAVSATTNINGSSTATISTIK', 'S']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAVPLATSSTATISTIK=Gravplatsstatistik;GRAVSATTNINGSSTATISTIK=Gravsättningsstatistik"',
          GUIEditable: true,
        },
        INST: {
          AttributeName: 'INST',
          DisplayLabel: 'Egenskaper',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISA_INST: {
          AttributeName: 'VISA_INST',
          DisplayLabel: 'Visa kod/benämning',
          Hint: 'Fullständig benämning/Endast benämning/Endast kod',
          DataType: 'Enum',
          EnumValues: new Map([['FULLSTANDIG_BENAMNING', 'Fullständig benämning'], ['ENDAST_BENAMNING', 'Endast benämning'], ['ENDAST_KOD', 'Endast kod']]),
          EnumSortValues: new Map([['FULLSTANDIG_BENAMNING', 'F'], ['ENDAST_BENAMNING', 'B'], ['ENDAST_KOD', 'K']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FULLSTANDIG_BENAMNING=Fullständig benämning;ENDAST_BENAMNING=Endast benämning;ENDAST_KOD=Endast kod"',
        },
        GRUPP1_TYP: {
          AttributeName: 'GRUPP1_TYP',
          DisplayLabel: 'Grupperingsbegrepp 1',
          Hint: 'Kyrkogård/Kvarter/Avdelning/Malltyp/Mall',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKOGARD', 'Kyrkogård'], ['KVARTER', 'Kvarter'], ['AVDELNING', 'Avdelning'], ['MALLTYP', 'Malltyp'], ['MALL', 'Mall']]),
          EnumSortValues: new Map([['KYRKOGARD', 'K'], ['KVARTER', 'V'], ['AVDELNING', 'D'], ['MALLTYP', 'T'], ['MALL', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKOGARD=Kyrkogård;KVARTER=Kvarter;AVDELNING=Avdelning;MALLTYP=Malltyp;MALL=Mall"',
        },
        GRUPP1_INST: {
          AttributeName: 'GRUPP1_INST',
          DisplayLabel: 'Grupperingsbegrepp 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP2_TYP: {
          AttributeName: 'GRUPP2_TYP',
          DisplayLabel: 'Grupperingsbegrepp 2',
          Hint: 'Kyrkogård/Kvarter/Avdelning/Malltyp/Mall',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKOGARD', 'Kyrkogård'], ['KVARTER', 'Kvarter'], ['AVDELNING', 'Avdelning'], ['MALLTYP', 'Malltyp'], ['MALL', 'Mall']]),
          EnumSortValues: new Map([['KYRKOGARD', 'K'], ['KVARTER', 'V'], ['AVDELNING', 'D'], ['MALLTYP', 'T'], ['MALL', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKOGARD=Kyrkogård;KVARTER=Kvarter;AVDELNING=Avdelning;MALLTYP=Malltyp;MALL=Mall"',
        },
        GRUPP2_INST: {
          AttributeName: 'GRUPP2_INST',
          DisplayLabel: 'Grupperingsbegrepp 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP3_TYP: {
          AttributeName: 'GRUPP3_TYP',
          DisplayLabel: 'Grupperingsbegrepp 3',
          Hint: 'Kyrkogård/Kvarter/Avdelning/Malltyp/Mall',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKOGARD', 'Kyrkogård'], ['KVARTER', 'Kvarter'], ['AVDELNING', 'Avdelning'], ['MALLTYP', 'Malltyp'], ['MALL', 'Mall']]),
          EnumSortValues: new Map([['KYRKOGARD', 'K'], ['KVARTER', 'V'], ['AVDELNING', 'D'], ['MALLTYP', 'T'], ['MALL', 'M']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKOGARD=Kyrkogård;KVARTER=Kvarter;AVDELNING=Avdelning;MALLTYP=Malltyp;MALL=Mall"',
        },
        GRUPP3_INST: {
          AttributeName: 'GRUPP3_INST',
          DisplayLabel: 'Grupperingsbegrepp 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOLUMNTYPER: {
          AttributeName: 'KOLUMNTYPER',
          DisplayLabel: 'Kolumntyper',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kolumner: {
          AssociationName: 'Kolumner',
          DisplayLabel: 'Kolumner',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravListKol',
          AssociatedComponentName: 'GravListKol',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    GAGravrattHist: {
      CollectionName: 'GAGravrattHist',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravrattHist',
        Abstract: false,
        SOLabel: 'Gravrättshistorik',
        SOGLabel: 'Gravrättshistorik',
        SBLabel: 'Gravrättshistoriken',
        SBGLabel: 'Gravrättshistoriken',
        POLabel: 'Gravrättshistorik',
        POGLabel: 'Gravrättshistorik',
        PBLabel: 'Gravrättshistoriken',
        PBGLabel: 'Gravrättshistoriken',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gravrättshistoriken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gravrättshistoriken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gravrättshistoriken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gravrättshistoriken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GILTIG_DATUM: {
          AttributeName: 'GILTIG_DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=0',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          Required: true,
        },
        AUTO: {
          AttributeName: 'AUTO',
          DisplayLabel: 'Automatisk',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVRATT_FR: {
          AttributeName: 'GRAVRATT_FR',
          DisplayLabel: 'Gravrätt fr.o.m.',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=60',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        GRAVRATT_TI: {
          AttributeName: 'GRAVRATT_TI',
          DisplayLabel: 'Gravrätt t.o.m.',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=60',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        ORSAK: {
          AttributeName: 'ORSAK',
          DisplayLabel: 'Orsak',
          Hint: 'Tidigaste upplåtelse/Upplåtelse/Förnyelse/Förlängning/Ändring',
          DataType: 'Enum',
          EnumValues: new Map([['TIDIGASTE_UPPLATELSE', 'Tidigaste upplåtelse'], ['UPPLATELSE', 'Upplåtelse'], ['FORNYELSE', 'Förnyelse'], ['FORLANGNING', 'Förlängning'], ['ANDRING', 'Ändring']]),
          EnumSortValues: new Map([['TIDIGASTE_UPPLATELSE', 'D'], ['UPPLATELSE', 'U'], ['FORNYELSE', 'F'], ['FORLANGNING', 'G'], ['ANDRING', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="TIDIGASTE_UPPLATELSE=Tidigaste upplåtelse;UPPLATELSE=Upplåtelse;FORNYELSE=Förnyelse;FORLANGNING=Förlängning;ANDRING=Ändring"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Required: true,
        },
        ANDRAD_DATUM: {
          AttributeName: 'ANDRAD_DATUM',
          DisplayLabel: 'Ändringsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        ANDRAD_SIGNATUR: {
          AttributeName: 'ANDRAD_SIGNATUR',
          DisplayLabel: 'Ändrad av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANTAL_AR: {
          AttributeName: 'ANTAL_AR',
          DisplayLabel: 'Antal år',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Andrad: {
          AttributeName: 'Andrad',
          DisplayLabel: 'Ändrad',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Gravplats: {
          AssociationName: 'Gravplats',
          DisplayLabel: 'Gravplats',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Gravplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGRIHistorik: {
      CollectionName: 'GAGRIHistorik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GRIHistorik',
        Abstract: false,
        SOLabel: 'Gravrättsinnehavare',
        SOGLabel: 'Gravrättsinnehavare',
        SBLabel: 'Gravrättsinnehavaren',
        SBGLabel: 'Gravrättsinnehavaren',
        POLabel: 'Gravrättsinnehavare',
        POGLabel: 'Gravrättsinnehavare',
        PBLabel: 'Gravrättsinnehavarna',
        PBGLabel: 'Gravrättsinnehavarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gravrättsinnehavaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gravrättsinnehavaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gravrättsinnehavaren id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gravrättsinnehavaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          GUIEditable: true,
          MaxInputLength: 13,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        EFTERNAMN: {
          AttributeName: 'EFTERNAMN',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FORNAMN: {
          AttributeName: 'FORNAMN',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ADRESS: {
          AttributeName: 'ADRESS',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'Paragraphs=" True"',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        LAND: {
          AttributeName: 'LAND',
          DisplayLabel: 'Land',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ANTECKNINGAR: {
          AttributeName: 'ANTECKNINGAR',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DATUM_FR: {
          AttributeName: 'DATUM_FR',
          DisplayLabel: 'Datum fr o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM_TI: {
          AttributeName: 'DATUM_TI',
          DisplayLabel: 'Datum t o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn (efternamn, förnamn)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnFE: {
          AttributeName: 'NamnFE',
          DisplayLabel: 'Namn (förnamn efternamn)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Datum: {
          AttributeName: 'Datum',
          DisplayLabel: 'Datumintervall (fr o m - t o m)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NamnAdressRad: {
          AttributeName: 'NamnAdressRad',
          DisplayLabel: 'Namn och adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnEFF: {
          AttributeName: 'NamnEFF',
          DisplayLabel: 'Namn (efternamn fullständig förenamn)',
          Hint: 'Organisationsnamn eller Förnamn Efternamn - Ja/Nej',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Gravplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravsatt: {
      CollectionName: 'GAGravsatt',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '3'], ['BLANKETT_GRAVPLATS_BASE', 'Begravningsplats']]),
      RootType: {
        TypeValue: 'Gravsatt',
        Abstract: true,
        SOLabel: 'Gravsatt',
        SOGLabel: 'Gravsatts',
        SBLabel: 'Gravsatta',
        SBGLabel: 'Gravsattas',
        POLabel: 'Gravsatta',
        POGLabel: 'Gravsattas',
        PBLabel: 'Gravsatta',
        PBGLabel: 'Gravsattas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'GravsattGravplats',
            Abstract: false,
            SOLabel: 'Gravsatt i gravplats',
            SOGLabel: 'Gravsatts i gravplats',
            SBLabel: 'Gravsatta i gravplats',
            SBGLabel: 'Gravsattas i gravplats',
            POLabel: 'Gravsatta i gravplats',
            POGLabel: 'Gravsattas i gravplats',
            PBLabel: 'Gravsatta i gravplats',
            PBGLabel: 'Gravsattas i gravplats',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'GravsattMinneslund',
            Abstract: false,
            SOLabel: 'Gravsatt i minneslund',
            SOGLabel: 'Gravsatts i minneslund',
            SBLabel: 'Gravsatta i minneslund',
            SBGLabel: 'Gravsattas i minneslund',
            POLabel: 'Gravsatta i minneslund',
            POGLabel: 'Gravsattas i minneslund',
            PBLabel: 'Gravsatta i minneslund',
            PBGLabel: 'Gravsattas i minneslund',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'GravsattAnnanOrt',
            Abstract: false,
            SOLabel: 'Gravsatt på annan ort',
            SOGLabel: 'Gravsatts på annan ort',
            SBLabel: 'Gravsatta på annan ort',
            SBGLabel: 'Gravsattas på annan ort',
            POLabel: 'Gravsatta på annan ort',
            POGLabel: 'Gravsattas på annan ort',
            PBLabel: 'Gravsatta på annan ort',
            PBGLabel: 'Gravsattas på annan ort',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'GravsattAskgravlund',
            Abstract: false,
            SOLabel: 'Gravsatt i askgravlund',
            SOGLabel: 'Gravsatts i askgravlund',
            SBLabel: 'Gravsatta i askgravlund',
            SBGLabel: 'Gravsattas i askgravlund',
            POLabel: 'Gravsatta i askgravlund',
            POGLabel: 'Gravsattas i askgravlund',
            PBLabel: 'Gravsatta i askgravlund',
            PBGLabel: 'Gravsattas i askgravlund',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gravsattas primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gravsattas versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVSATTGRAVPLATS', 'Gravsatt i gravplats'], ['GRAVSATTMINNESLUND', 'Gravsatt i minneslund'], ['GRAVSATTANNANORT', 'Gravsatt på annan ort'], ['GRAVSATTASKGRAVLUND', 'Gravsatt i askgravlund']]),
          EnumSortValues: new Map([['GRAVSATTGRAVPLATS', 'G'], ['GRAVSATTMINNESLUND', 'M'], ['GRAVSATTANNANORT', 'O'], ['GRAVSATTASKGRAVLUND', 'S']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAVSATTGRAVPLATS=Gravsatt i gravplats;GRAVSATTMINNESLUND=Gravsatt i minneslund;GRAVSATTANNANORT=Gravsatt på annan ort;GRAVSATTASKGRAVLUND=Gravsatt i askgravlund"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gravsattas id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gravsattas fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          Hint: 'Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnFE: {
          AttributeName: 'NamnFE',
          DisplayLabel: 'Namn (förnamn efternamn)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        VISA_EJ_PA_FRAMSIDAN: {
          AttributeName: 'VISA_EJ_PA_FRAMSIDAN',
          DisplayLabel: 'Publiceras',
          Hint: 'Ej klar/Publiceras ej/Publiceras/Publiceras om skydd upphör',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_KLAR', 'Ej klar'], ['PUBLICERAS_EJ', 'Publiceras ej'], ['PUBLICERAS', 'Publiceras'], ['PUBLICERAS_OM_SKYDD_UPPHOR', 'Publiceras om skydd upphör']]),
          EnumSortValues: new Map([['EJ_KLAR', 'N'], ['PUBLICERAS_EJ', 'Y'], ['PUBLICERAS', 'P'], ['PUBLICERAS_OM_SKYDD_UPPHOR', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_KLAR=Ej klar;PUBLICERAS_EJ=Publiceras ej;PUBLICERAS=Publiceras;PUBLICERAS_OM_SKYDD_UPPHOR=Publiceras om skydd upphör"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        PUBLICERA_SIGNATUR: {
          AttributeName: 'PUBLICERA_SIGNATUR',
          DisplayLabel: 'Publicering, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PUBLICERA_DATUM: {
          AttributeName: 'PUBLICERA_DATUM',
          DisplayLabel: 'Publicering, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PUBLICERA_NOTERING: {
          AttributeName: 'PUBLICERA_NOTERING',
          DisplayLabel: 'Publicera, notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DJUP: {
          AttributeName: 'DJUP',
          DisplayLabel: 'Djup',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterDisplayParams: 'ForceDecimals="Y"',
          FormatterValidateParams: 'MinValue="0";MaxValue="9"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['GravsattGravplats', 'GravsattAskgravlund'],
          AttributeGroup: 'Placering',
        },
        URNPLATS: {
          AttributeName: 'URNPLATS',
          DisplayLabel: 'Urnplats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GravsattGravplats'],
          AttributeGroup: 'Placering',
        },
        KISTPLATS: {
          AttributeName: 'KISTPLATS',
          DisplayLabel: 'Kistplats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GravsattGravplats'],
          AttributeGroup: 'Placering',
        },
        PLAC_ANM: {
          AttributeName: 'PLAC_ANM',
          DisplayLabel: 'Placering, askgravlund',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GravsattAskgravlund'],
          AttributeGroup: 'Placering',
        },
        Placering: {
          AttributeName: 'Placering',
          DisplayLabel: 'Placering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GravsattGravplats', 'GravsattAskgravlund'],
          AttributeGroup: 'Placering',
        },
        Placering2: {
          AttributeName: 'Placering2',
          DisplayLabel: 'Placering och typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GravsattGravplats', 'GravsattAskgravlund'],
          AttributeGroup: 'Placering',
        },
        Malltyp: {
          AttributeName: 'Malltyp',
          DisplayLabel: 'Malltyp',
          Hint: 'Kistmall/Urnmall/Kombinationsmall',
          DataType: 'Enum',
          EnumValues: new Map([['KISTMALL', 'Kistmall'], ['URNMALL', 'Urnmall'], ['KOMBINATIONSMALL', 'Kombinationsmall']]),
          EnumSortValues: new Map([['KISTMALL', 'K'], ['URNMALL', 'U'], ['KOMBINATIONSMALL', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KISTMALL=Kistmall;URNMALL=Urnmall;KOMBINATIONSMALL=Kombinationsmall"',
          InterfaceType: 'ifChecklist',
          ValidInComps: ['GravsattGravplats'],
          AttributeGroup: 'Mall',
        },
        Urnmall: {
          AttributeName: 'Urnmall',
          DisplayLabel: 'Urnmall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['GravsattGravplats'],
          AttributeGroup: 'Mall',
        },
        Kistmall: {
          AttributeName: 'Kistmall',
          DisplayLabel: 'Kistmall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['GravsattGravplats'],
          AttributeGroup: 'Mall',
        },
        GRAVS_ORT: {
          AttributeName: 'GRAVS_ORT',
          DisplayLabel: 'Gravsättningsort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GravsattAnnanOrt'],
        },
        SortNamnFullst: {
          AttributeName: 'SortNamnFullst',
          DisplayLabel: 'Sortering, Namn, Fullst förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SortFNamnFullst: {
          AttributeName: 'SortFNamnFullst',
          DisplayLabel: 'Sortering, Fullst förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVLIDEN_REF_ID: {
          AttributeName: 'AVLIDEN_REF_ID',
          DisplayLabel: 'Avliden',
          Hint: 'Ja/Nej',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        CheckDjup: {
          AssociationName: 'CheckDjup',
          DisplayLabel: 'Djup',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravDjup',
          AssociatedComponentName: 'GravDjup',
          JoinAssociation: true,
          ValidInComps: ['GravsattGravplats'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomJoin', '{Alias.GRAV_ID} = {FromAlias.GRAV_ID} and {FromAlias.DJUP} between {Alias.MINDJUP} and isnull({Alias.MAXDJUP},{Alias.MINDJUP})']]),
        },
        Avlidna: {
          AssociationName: 'Avlidna',
          DisplayLabel: 'Avlidna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'Avliden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAHandelseGRI: {
      CollectionName: 'GAHandelseGRI',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'HandelseGRI',
        Abstract: false,
        SOLabel: 'GRI händelse',
        SOGLabel: 'GRI händelses',
        SBLabel: 'GRI händelsen',
        SBGLabel: 'GRI händelsens',
        POLabel: 'GRI händelser',
        POGLabel: 'GRI händelsers',
        PBLabel: 'GRI händelserna',
        PBGLabel: 'GRI händelsernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GRI händelsens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GRI händelsens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GRI händelsens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'Händelse',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    GAHandelse: {
      CollectionName: 'GAHandelse',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '21001']]),
      RootType: {
        TypeValue: 'Handelse',
        Abstract: true,
        SOLabel: 'Händelse',
        SOGLabel: 'Händelses',
        SBLabel: 'Händelsen',
        SBGLabel: 'Händelsens',
        POLabel: 'Händelser',
        POGLabel: 'Händelsers',
        PBLabel: 'Händelserna',
        PBGLabel: 'Händelsernas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Utskick',
            Abstract: false,
            SOLabel: 'Utskick',
            SOGLabel: 'Utskicks',
            SBLabel: 'Utskicket',
            SBGLabel: 'Utskickets',
            POLabel: 'Utskick',
            POGLabel: 'Utskicks',
            PBLabel: 'Utskicken',
            PBGLabel: 'Utskickens',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'HandelseRad',
            Abstract: false,
            SOLabel: 'Händelserad',
            SOGLabel: 'Händelserads',
            SBLabel: 'Händelseraden',
            SBGLabel: 'Händelseradens',
            POLabel: 'Händelserader',
            POGLabel: 'Händelseraders',
            PBLabel: 'Händelseraderna',
            PBGLabel: 'Händelseradernas',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Manuell',
            Abstract: false,
            SOLabel: 'Manuell händelse',
            SOGLabel: 'Manuell händelses',
            SBLabel: 'Den manuella händelsen',
            SBGLabel: 'Den manuella händelsens',
            POLabel: 'Manuella händelser',
            POGLabel: 'Manuella händelsers',
            PBLabel: 'De manuella händelserna',
            PBGLabel: 'De manuella händelsernas',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Händelsens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Händelsens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['UTSKICK', 'Utskick'], ['HANDELSERAD', 'Händelserad'], ['MANUELL', 'Manuell händelse']]),
          EnumSortValues: new Map([['UTSKICK', 'U'], ['HANDELSERAD', 'R'], ['MANUELL', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Händelsens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Händelsens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PARENT_ID: {
          AttributeName: 'PARENT_ID',
          DisplayLabel: 'Tillhör händelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum och tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          FormatterDisplayParams: 'HideZeroTime="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Dokument',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATA_NAMN: {
          AttributeName: 'DATA_NAMN',
          DisplayLabel: 'Dokumentnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAV_ID: {
          AttributeName: 'GRAV_ID',
          DisplayLabel: 'Grav',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SYS_HANDELSE_ID: {
          AttributeName: 'SYS_HANDELSE_ID',
          DisplayLabel: 'Systemhändelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KLAR: {
          AttributeName: 'KLAR',
          DisplayLabel: 'Status',
          Hint: 'Notering/Arbetsuppgift/Utredning/Återrapportering/Klar',
          DataType: 'Enum',
          EnumValues: new Map([['NOTERING', 'Notering'], ['ARBETSUPPGIFT', 'Arbetsuppgift'], ['UTREDNING', 'Utredning'], ['ATERRAPPORTERING', 'Återrapportering'], ['KLAR', 'Klar']]),
          EnumSortValues: new Map([['NOTERING', 'N'], ['ARBETSUPPGIFT', 'A'], ['UTREDNING', 'U'], ['ATERRAPPORTERING', 'R'], ['KLAR', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NOTERING=Notering;ARBETSUPPGIFT=Arbetsuppgift;UTREDNING=Utredning;ATERRAPPORTERING=Återrapportering;KLAR=Klar"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['HandelseRad'],
        },
        BEVAKNINGSDATUM: {
          AttributeName: 'BEVAKNINGSDATUM',
          DisplayLabel: 'Bevakningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MinRecommendedDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['HandelseRad'],
        },
        MOTTAGARE: {
          AttributeName: 'MOTTAGARE',
          DisplayLabel: 'Mottagare',
          Hint: 'Alla mottagares namn som en kommaseparerad lista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['HandelseRad'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DatumDatum: {
          AttributeName: 'DatumDatum',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DatumTid: {
          AttributeName: 'DatumTid',
          DisplayLabel: 'Tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Status, Datum och tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          FormatterDisplayParams: 'HideZeroTime="Y"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATUS_SIGNATUR: {
          AttributeName: 'STATUS_SIGNATUR',
          DisplayLabel: 'Status, Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SortStatus: {
          AttributeName: 'SortStatus',
          DisplayLabel: 'SortStatus',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bevakad: {
          AttributeName: 'Bevakad',
          DisplayLabel: 'Bevakad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['HandelseRad'],
        },
        StatusKlar: {
          AttributeName: 'StatusKlar',
          DisplayLabel: 'Klar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['HandelseRad'],
        },
        STATUS_WEBAVENY: {
          AttributeName: 'STATUS_WEBAVENY',
          DisplayLabel: 'Status ändrad i WebAveny',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        StatusAndrad: {
          AttributeName: 'StatusAndrad',
          DisplayLabel: 'Status ändrad',
          Hint: 'Datum, signatur, WebAveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BJ_ID: {
          AttributeName: 'BJ_ID',
          DisplayLabel: 'Bisättningsjournal ID',
          Hint: 'Ja/Nej',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'Aktivitet ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSVARIG_ID: {
          AttributeName: 'ANSVARIG_ID',
          DisplayLabel: 'Ansvarig ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Parent: {
          AssociationName: 'Parent',
          DisplayLabel: 'Händelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Gravplats',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: ['HandelseRad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SystemHandelse: {
          AssociationName: 'SystemHandelse',
          DisplayLabel: 'Systemhändelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SysHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bisattning: {
          AssociationName: 'Bisattning',
          DisplayLabel: 'Bisättning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: ['HandelseRad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Ansvarig: {
          AssociationName: 'Ansvarig',
          DisplayLabel: 'Ansvarig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravHandelseAnsvarig',
          AssociatedComponentName: 'GravHandelseAnsvarigSaml',
          JoinAssociation: true,
          ValidInComps: ['HandelseRad'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'ANSVARIG_NAMN']]),
        },
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: ['HandelseRad'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelseMottagare',
          AssociatedComponentName: 'HandelseMottagare',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        MottagareGrav: {
          AssociationName: 'MottagareGrav',
          DisplayLabel: 'Mottagare per grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelseMottagare',
          AssociatedComponentName: 'HandelseMottagare',
          JoinAssociation: false,
          ValidInComps: ['HandelseRad'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Children: {
          AssociationName: 'Children',
          DisplayLabel: 'Händelserader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: false,
          ValidInComps: ['Utskick', 'Manuell'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        MottagareBisattning: {
          AssociationName: 'MottagareBisattning',
          DisplayLabel: 'Mottagare bisättning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningMottagare',
          AssociatedComponentName: 'BisattningMottagare',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        MottagareAktivitet: {
          AssociationName: 'MottagareAktivitet',
          DisplayLabel: 'Mottagare aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitetMottagare',
          AssociatedComponentName: 'AktivitetMottagare',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravListKol: {
      CollectionName: 'GAGravListKol',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'GravListKol',
        Abstract: false,
        SOLabel: 'Kolumn',
        SOGLabel: 'Kolumn',
        SBLabel: 'Kolumnen',
        SBGLabel: 'Kolumnen',
        POLabel: 'Kolumner',
        POGLabel: 'Kolumner',
        PBLabel: 'Kolumnerna',
        PBGLabel: 'Kolumnerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kolumnen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kolumnen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kolumnen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kolumnen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
          Required: true,
        },
        ORDNING: {
          AttributeName: 'ORDNING',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Gravrätter/Återlämnade/Återtagna/Totalsumma/Befintlig grav/Ny eller nyupplåten grav/Ny grav/Nyupplåten grav',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVRATTER', 'Gravrätter'], ['ATERLAMNADE_ATERTAGNA', 'Återlämnade/Återtagna'], ['TOTALSUMMA', 'Totalsumma'], ['BEFINTLIG_GRAV', 'Befintlig grav'], ['NY_ELLER_NYUPPLATEN_GRAV', 'Ny eller nyupplåten grav'], ['NY_GRAV', 'Ny grav'], ['NYUPPLATEN_GRAV', 'Nyupplåten grav']]),
          EnumSortValues: new Map([['GRAVRATTER', 'G'], ['ATERLAMNADE_ATERTAGNA', 'A'], ['TOTALSUMMA', 'T'], ['BEFINTLIG_GRAV', 'B'], ['NY_ELLER_NYUPPLATEN_GRAV', 'N'], ['NY_GRAV', 'E'], ['NYUPPLATEN_GRAV', 'U']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAVRATTER=Gravrätter;ATERLAMNADE_ATERTAGNA=Återlämnade/Återtagna;TOTALSUMMA=Totalsumma;BEFINTLIG_GRAV=Befintlig grav;NY_ELLER_NYUPPLATEN_GRAV=Ny eller nyupplåten grav;NY_GRAV=Ny grav;NYUPPLATEN_GRAV=Nyupplåten grav"',
          GUIEditable: true,
          Required: true,
        },
        UPPDELNING: {
          AttributeName: 'UPPDELNING',
          DisplayLabel: 'Uppdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lista: {
          AssociationName: 'Lista',
          DisplayLabel: 'Lista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravList',
          AssociatedComponentName: 'GravList',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GASkotListKol: {
      CollectionName: 'GASkotListKol',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'SkotListKol',
        Abstract: false,
        SOLabel: 'Kolumn',
        SOGLabel: 'Kolumn',
        SBLabel: 'Kolumnen',
        SBGLabel: 'Kolumnen',
        POLabel: 'Kolumner',
        POGLabel: 'Kolumner',
        PBLabel: 'Kolumnerna',
        PBGLabel: 'Kolumnerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kolumnen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kolumnen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kolumnen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kolumnen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
          Required: true,
        },
        ORDNING: {
          AttributeName: 'ORDNING',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Antal/Pris/Gravar',
          DataType: 'Enum',
          EnumValues: new Map([['ANTAL', 'Antal'], ['PRIS', 'Pris'], ['GRAVAR', 'Gravar']]),
          EnumSortValues: new Map([['ANTAL', 'A'], ['PRIS', 'P'], ['GRAVAR', 'G']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANTAL=Antal;PRIS=Pris;GRAVAR=Gravar"',
          GUIEditable: true,
        },
        DEB_SATT: {
          AttributeName: 'DEB_SATT',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UPPDELNING: {
          AttributeName: 'UPPDELNING',
          DisplayLabel: 'Uppdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lista: {
          AssociationName: 'Lista',
          DisplayLabel: 'Lista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GASkotList',
          AssociatedComponentName: 'SkotList',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAKontakt: {
      CollectionName: 'GAKontakt',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '10'], ['BLANKETT_GRAVPLATS_BASE', 'Grav'], ['Utskick', 'Y'], ['OPL_FIELD', 'OPID']]),
      RootType: {
        TypeValue: 'Kontakt',
        Abstract: true,
        SOLabel: 'Kontakt',
        SOGLabel: 'Kontakt',
        SBLabel: 'Kontakten',
        SBGLabel: 'Kontakten',
        POLabel: 'Kontakter',
        POGLabel: 'Kontakter',
        PBLabel: 'Kontakterna',
        PBGLabel: 'Kontakterna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'KontaktOrgPers',
            Abstract: true,
            SOLabel: 'Organisation/Person',
            SOGLabel: 'Organisation/Person',
            SBLabel: 'Organisationen/Personen',
            SBGLabel: 'Organisationen/Personen',
            POLabel: 'Organisationer/Personer',
            POGLabel: 'Organisationer/Personer',
            PBLabel: 'Organisationerna/Personerna',
            PBGLabel: 'Organisationerna/Personerna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Gravrattsinnehavare',
                Abstract: false,
                SOLabel: 'Gravrättsinnehavare',
                SOGLabel: 'Gravrättsinnehavare',
                SBLabel: 'Gravrättsinnehavaren',
                SBGLabel: 'Gravrättsinnehavaren',
                POLabel: 'Gravrättsinnehavare',
                POGLabel: 'Gravrättsinnehavare',
                PBLabel: 'Gravrättsinnehavarna',
                PBGLabel: 'Gravrättsinnehavarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'KontaktOvrig',
                Abstract: false,
                SOLabel: 'Övrig kontakt',
                SOGLabel: 'Övrig kontakt',
                SBLabel: 'Övriga kontakten',
                SBGLabel: 'Övriga kontakten',
                POLabel: 'Övriga kontakter',
                POGLabel: 'Övriga kontakter',
                PBLabel: 'Övriga kontakterna',
                PBGLabel: 'Övriga kontakterna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Betalningsansvarig',
            Abstract: false,
            SOLabel: 'Betalningsansvarig',
            SOGLabel: 'Betalningsansvarig',
            SBLabel: 'Betalningsansvarige',
            SBGLabel: 'Betalningsansvarige',
            POLabel: 'Betalningsansvariga',
            POGLabel: 'Betalningsansvariga',
            PBLabel: 'Betalningsansvariga',
            PBGLabel: 'Betalningsansvariga',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Dodsbo',
            Abstract: false,
            SOLabel: 'Dödsbo',
            SOGLabel: 'Dödsbos',
            SBLabel: 'Dödsboet',
            SBGLabel: 'Dödsboets',
            POLabel: 'Dödsbon',
            POGLabel: 'Dödsbons',
            PBLabel: 'Dödsbona',
            PBGLabel: 'Dödsbonas',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kontakten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kontakten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVRATTSINNEHAVARE', 'Gravrättsinnehavare'], ['KONTAKTOVRIG', 'Övrig kontakt'], ['BETALNINGSANSVARIG', 'Betalningsansvarig'], ['DODSBO', 'Dödsbo']]),
          EnumSortValues: new Map([['GRAVRATTSINNEHAVARE', 'G'], ['KONTAKTOVRIG', 'K'], ['BETALNINGSANSVARIG', 'B'], ['DODSBO', 'D']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kontakten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kontakten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNINGAR: {
          AttributeName: 'ANTECKNINGAR',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Borttagen',
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          Hint: 'Grav återlämnad/återtagen',
          DataType: 'Enum',
          EnumValues: new Map([['GRAV_ATERLAMNAD_ATERTAGEN', 'Grav återlämnad/återtagen']]),
          EnumSortValues: new Map([['GRAV_ATERLAMNAD_ATERTAGEN', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAV_ATERLAMNAD_ATERTAGEN=Grav återlämnad/återtagen"',
          AttributeGroup: 'Borttagen',
        },
        KontaktTyp: {
          AttributeName: 'KontaktTyp',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KontaktTypLong: {
          AttributeName: 'KontaktTypLong',
          DisplayLabel: 'Kontakttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NamnTyp: {
          AttributeName: 'NamnTyp',
          DisplayLabel: 'Namn och typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RefBorttagen: {
          AttributeName: 'RefBorttagen',
          DisplayLabel: 'RefBorttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        OPBorttagen: {
          AttributeName: 'OPBorttagen',
          DisplayLabel: 'OPBorttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        RefOrOPBorttagen: {
          AttributeName: 'RefOrOPBorttagen',
          DisplayLabel: 'RefOrOPBorttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        OPLokalAdr: {
          AttributeName: 'OPLokalAdr',
          DisplayLabel: 'Lokal adress (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        OPID: {
          AttributeName: 'OPID',
          DisplayLabel: 'OPID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Adress',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['KontaktOrgPers'],
        },
        KONTAKTPERSON: {
          AttributeName: 'KONTAKTPERSON',
          DisplayLabel: 'Postmottagare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOrgPers'],
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Ombud/Gravr.inh./God man',
          DataType: 'Enum',
          EnumValues: new Map([['OMBUD_GRAVR_INH_', 'Ombud/Gravr.inh.'], ['GOD_MAN', 'God man']]),
          EnumSortValues: new Map([['OMBUD_GRAVR_INH_', 'O'], ['GOD_MAN', 'G']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="OMBUD_GRAVR_INH_=Ombud/Gravr.inh.;GOD_MAN=God man"',
          ValidInComps: ['KontaktOrgPers'],
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fr.o.m. datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Gravrattsinnehavare'],
        },
        Ombud: {
          AttributeName: 'Ombud',
          DisplayLabel: 'Ombud',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gravrattsinnehavare'],
        },
        GODMAN_P_ID: {
          AttributeName: 'GODMAN_P_ID',
          DisplayLabel: 'God man för',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['KontaktOvrig'],
        },
        GodMan: {
          AttributeName: 'GodMan',
          DisplayLabel: 'God man',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOvrig'],
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'Kund',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Betalningsansvarig'],
        },
        Debsatt: {
          AttributeName: 'Debsatt',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Betalningsansvarig'],
        },
        DebsattNr: {
          AttributeName: 'DebsattNr',
          DisplayLabel: 'Debiteringssätt och kund/avtal',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Betalningsansvarig'],
        },
        DebsattNrNamn: {
          AttributeName: 'DebsattNrNamn',
          DisplayLabel: 'Debiteringssätt, kund/avtal och namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Betalningsansvarig'],
        },
        Debsatt2NrNamnFE: {
          AttributeName: 'Debsatt2NrNamnFE',
          DisplayLabel: 'Debiteringssätt, kund/avtal och namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Betalningsansvarig'],
        },
        KontoSaldoAktuellt: {
          AttributeName: 'KontoSaldoAktuellt',
          DisplayLabel: 'Saldo/Tillgodo',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Betalningsansvarig'],
        },
        SortKontaktTyp: {
          AttributeName: 'SortKontaktTyp',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IsBetAnsv: {
          AttributeName: 'IsBetAnsv',
          DisplayLabel: 'Betalningsansvarig',
          Hint: 'Personen/organisationen är också betalningsansvarig på gravplatsen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOrgPers'],
          AttributeGroup: 'Åtaganden',
        },
        IsGRI: {
          AttributeName: 'IsGRI',
          DisplayLabel: 'Gravrättsinnehavare',
          Hint: 'Personen/organisationen är också gravrättsinnehavare på gravplatsen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Betalningsansvarig', 'KontaktOvrig'],
          AttributeGroup: 'Åtaganden',
        },
        IsBetAnsvF: {
          AttributeName: 'IsBetAnsvF',
          DisplayLabel: 'Betalningsansvarig, fakturakund',
          Hint: 'Personen/organisationen är också fakturakund på gravplatsen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOrgPers'],
          AttributeGroup: 'Åtaganden',
        },
        IsBetAnsvK: {
          AttributeName: 'IsBetAnsvK',
          DisplayLabel: 'Betalningsansvarig, avräkningsavtal',
          Hint: 'Personen/organisationen har också ett avräkningsavtal kopplat till gravplatsen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOrgPers'],
          AttributeGroup: 'Åtaganden',
        },
        IsBetAnsvA: {
          AttributeName: 'IsBetAnsvA',
          DisplayLabel: 'Betalningsansvarig, fasttidsavtal',
          Hint: 'Personen/organisationen har också ett fasttidsavtal kopplat till gravplatsen - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOrgPers'],
          AttributeGroup: 'Åtaganden',
        },
        KontaktTypShort: {
          AttributeName: 'KontaktTypShort',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenasteHandelse: {
          AttributeName: 'SenasteHandelse',
          DisplayLabel: 'Senaste händelse',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTimeGeneral',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          AttributeGroup: 'Övrigt',
        },
        SenasteHandelseOP: {
          AttributeName: 'SenasteHandelseOP',
          DisplayLabel: 'Senaste händelse per adress',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTimeGeneral',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          AttributeGroup: 'Övrigt',
        },
        OPAvvikandeAdr: {
          AttributeName: 'OPAvvikandeAdr',
          DisplayLabel: 'Avvikande adress',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        ForordnandeFinns: {
          AttributeName: 'ForordnandeFinns',
          DisplayLabel: 'Förordnande finns',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KontaktOrgPers'],
        },
        KAMMARKOLLEGIETSARENDENR: {
          AttributeName: 'KAMMARKOLLEGIETSARENDENR',
          DisplayLabel: 'Kammarkollegiets ärende nr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
        },
        FakturakundTotalbeloppAr: {
          AttributeName: 'FakturakundTotalbeloppAr',
          DisplayLabel: 'Fakturakund totalbelopp (år)',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        GravrattForlangningDatum: {
          AttributeName: 'GravrattForlangningDatum',
          DisplayLabel: 'Datum för förlängning av gravrätt',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        GravrattForlangningAr: {
          AttributeName: 'GravrattForlangningAr',
          DisplayLabel: 'Antal år för förlängning av gravrätt',
          Hint: 'Ja/Nej',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVLIDEN_REF_ID: {
          AttributeName: 'AVLIDEN_REF_ID',
          DisplayLabel: 'Avliden',
          Hint: 'Ja/Nej',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PROCESS_STATUS: {
          AttributeName: 'PROCESS_STATUS',
          DisplayLabel: 'Process status från Utse gravrättsinnehavare',
          Hint: 'Ej skickat, anmälan/Skickat, anmälan/Skickat, påminnelse/Skickat, info till dödsboet/Skickat, gravbrev/GRI saknas',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_SKICKAT__ANMALAN', 'Ej skickat, anmälan'], ['SKICKAT__ANMALAN', 'Skickat, anmälan'], ['SKICKAT__PAMINNELSE', 'Skickat, påminnelse'], ['SKICKAT__INFO_TILL_DODSBOET', 'Skickat, info till dödsboet'], ['SKICKAT__GRAVBREV', 'Skickat, gravbrev'], ['GRI_SAKNAS', 'GRI saknas']]),
          EnumSortValues: new Map([['EJ_SKICKAT__ANMALAN', 'E'], ['SKICKAT__ANMALAN', 'A'], ['SKICKAT__PAMINNELSE', 'P'], ['SKICKAT__INFO_TILL_DODSBOET', 'G'], ['SKICKAT__GRAVBREV', 'R'], ['GRI_SAKNAS', 'S']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_SKICKAT__ANMALAN=Ej skickat, anmälan;SKICKAT__ANMALAN=Skickat, anmälan;SKICKAT__PAMINNELSE=Skickat, påminnelse;SKICKAT__INFO_TILL_DODSBOET=Skickat, info till dödsboet;SKICKAT__GRAVBREV=Skickat, gravbrev;GRI_SAKNAS=GRI saknas"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ARENDE_STATUS: {
          AttributeName: 'ARENDE_STATUS',
          DisplayLabel: 'Ärende status från Utse gravrättsinnehavare',
          Hint: 'Ej påbörjad/Inväntar svar/Svar, GRI anmälan/GRI saknas/Utred/Överskriden tid/Saknar mottagare/Överklagat/Slutförd',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_PABORJAD', 'Ej påbörjad'], ['INVANTAR_SVAR', 'Inväntar svar'], ['SVAR__GRI_ANMALAN', 'Svar, GRI anmälan'], ['GRI_SAKNAS', 'GRI saknas'], ['UTRED', 'Utred'], ['OVERSKRIDEN_TID', 'Överskriden tid'], ['SAKNAR_MOTTAGARE', 'Saknar mottagare'], ['OVERKLAGAT', 'Överklagat'], ['SLUTFORD', 'Slutförd']]),
          EnumSortValues: new Map([['EJ_PABORJAD', 'E'], ['INVANTAR_SVAR', 'I'], ['SVAR__GRI_ANMALAN', 'A'], ['GRI_SAKNAS', 'S'], ['UTRED', 'U'], ['OVERSKRIDEN_TID', 'O'], ['SAKNAR_MOTTAGARE', 'M'], ['OVERKLAGAT', 'B'], ['SLUTFORD', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_PABORJAD=Ej påbörjad;INVANTAR_SVAR=Inväntar svar;SVAR__GRI_ANMALAN=Svar, GRI anmälan;GRI_SAKNAS=GRI saknas;UTRED=Utred;OVERSKRIDEN_TID=Överskriden tid;SAKNAR_MOTTAGARE=Saknar mottagare;OVERKLAGAT=Överklagat;SLUTFORD=Slutförd"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenastHandelseDodsbo: {
          AttributeName: 'SenastHandelseDodsbo',
          DisplayLabel: 'Senaste händelse Dödsbo',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Dodsbo'],
        },
        DIARIENR_UTSE_GRI: {
          AttributeName: 'DIARIENR_UTSE_GRI',
          DisplayLabel: 'Diarienummer från Utse gravrättsinnehavare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
        },
        Brevmottagare: {
          AttributeName: 'Brevmottagare',
          DisplayLabel: 'Brevmottagare',
          Hint: 'Namn med tillägget "Till dödsbo för"',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BrevmottagareMedAdress: {
          AttributeName: 'BrevmottagareMedAdress',
          DisplayLabel: 'Brevmottagare med adress (Etikett)',
          Hint: 'Namn + adressetikett med tillägget "Till dödsbo för"',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AKTIVA_DODSBO: {
          AttributeName: 'AKTIVA_DODSBO',
          DisplayLabel: 'Visas i utse GRI',
          Hint: 'Ny gravplats, visas i utse gravrättsinnehavare - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenasteHandelseGri: {
          AttributeName: 'SenasteHandelseGri',
          DisplayLabel: 'Senaste händelse Gravrättsinnehavare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Dodsbo'],
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Grav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['PROPERTY_OPL', 'på'], ['PROPERTY_KUND', 'på']]),
        },
        OrgPers2: {
          AssociationName: 'OrgPers2',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['NOT_ATAGANDE', 'Y;'], ['OPL_NOCOMBINE', 'Y;'], ['OverrideDisplayLabels', 'G:Borttagen="Adress borttagen",BORTTAGEN="Adress borttagen",BORTTAGEN_DATUM="Adress borttagen datum",BORTTAGEN_SIGNATUR="Adress borttagen signatur"']]),
        },
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Adress',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: ['KontaktOrgPers'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GodMan: {
          AssociationName: 'GodMan',
          DisplayLabel: 'God man för',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['KontaktOvrig'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: ['Betalningsansvarig'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avlidna: {
          AssociationName: 'Avlidna',
          DisplayLabel: 'Avlidna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'Avliden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        SenasteHandelseDodsbo: {
          AssociationName: 'SenasteHandelseDodsbo',
          DisplayLabel: 'Senaste Händelser Dödsbo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: true,
          ValidInComps: ['Dodsbo'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SenasteHandelseGri: {
          AssociationName: 'SenasteHandelseGri',
          DisplayLabel: 'Senaste Händelser Gravrättsinnehavare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: true,
          ValidInComps: ['Gravrattsinnehavare'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Skotslar: {
          AssociationName: 'Skotslar',
          DisplayLabel: 'Skötslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: ['Betalningsansvarig'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelser: {
          AssociationName: 'Handelser',
          DisplayLabel: 'Händelser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.ID} in (select m.HANDELSE_ID from GA_HANDELSE_MOTTAGARE m where m.KONTAKT_ID = {FromAlias.GRAV_ID} and m.KONTAKT_LOPNR = {FromAlias.LOPNR})']]),
        },
        Handelserader: {
          AssociationName: 'Handelserader',
          DisplayLabel: 'Händelserader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.GRAV_ID} = {FromAlias.GRAV_ID} and {Alias.PARENT_ID} in (select m.HANDELSE_ID from GA_HANDELSE_MOTTAGARE m where m.KONTAKT_ID = {FromAlias.GRAV_ID} and m.KONTAKT_LOPNR = {FromAlias.LOPNR})']]),
        },
        HandelserOP: {
          AssociationName: 'HandelserOP',
          DisplayLabel: 'Händelser per adress',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.ID} in (select m.HANDELSE_ID from GA_HANDELSE_MOTTAGARE m join GA_KONTAKT ko on ko.GRAV_ID = m.KONTAKT_ID and ko.LOPNR = m.KONTAKT_LOPNR left outer join KR_KUND k on k.ID = ko.KUND_ID where (case when ko.TYP = \'B\' then k.OP_ID else ko.OP_ID end) = {FromAlias.OPID})']]),
        },
        OrderOmgOP: {
          AssociationName: 'OrderOmgOP',
          DisplayLabel: 'Orderomgångar per adress',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAOrderOmgSkotsel',
          AssociatedComponentName: 'OrderOmgSkotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.SKOTSEL_ID} = {FromAlias.GRAV_ID} and {Alias.ORDER_ID} in (select o.ID from OF_ORDER o join KR_KUND k on k.ID = o.KUND_ID where k.OP_ID = {FromAlias.OPID}) and isnull({Alias.STATUS},\'X\') = \'S\'']]),
        },
        GiltigaSkotslar: {
          AssociationName: 'GiltigaSkotslar',
          DisplayLabel: 'Giltiga skötslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: ['Betalningsansvarig'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{FromAlias.GRAV_ID} = {Alias.KONTAKT_ID} and {FromAlias.LOPNR} = {Alias.KONTAKT_LOPNR} and isnull({Alias.AR_TI},9999) >= datepart(yy,getdate()) and isnull({Alias.AR_TI},9999) >= isnull({Alias.AR_FR},0)']]),
        },
        HandelserDodsbo: {
          AssociationName: 'HandelserDodsbo',
          DisplayLabel: 'Händelser Dödsbo',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelseDodsbo',
          AssociatedComponentName: 'HandelseDodsbo',
          JoinAssociation: false,
          ValidInComps: ['Dodsbo'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        HandelserGrav: {
          AssociationName: 'HandelserGrav',
          DisplayLabel: 'Händelser på graven',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'HandelseRad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        VanvardGrav: {
          AssociationName: 'VanvardGrav',
          DisplayLabel: 'Vanvård på graven',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAVanvard',
          AssociatedComponentName: 'Vanvard',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravKultur: {
      CollectionName: 'GAGravKultur',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravKultur',
        Abstract: false,
        SOLabel: 'Kulturvärde',
        SOGLabel: 'Kulturvärdes',
        SBLabel: 'Kulturvärdet',
        SBGLabel: 'Kulturvärdets',
        POLabel: 'Kulturvärden',
        POGLabel: 'Kulturvärdens',
        PBLabel: 'Kulturvärdena',
        PBGLabel: 'Kulturvärdenas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kulturvärdets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kulturvärdets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kulturvärdets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kulturvärdets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesFilter', '{AKTIV} = \'Y\'']]),
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_ORSAK: {
          AttributeName: 'BORTTAGEN_ORSAK',
          DisplayLabel: 'Borttagen orsak',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STANDARD: {
          AttributeName: 'STANDARD',
          DisplayLabel: 'Standard',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAKvarter: {
      CollectionName: 'GAKvarter',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kvarter',
        Abstract: false,
        SOLabel: 'Kvarter',
        SOGLabel: 'Kvarter',
        SBLabel: 'Kvarteret',
        SBGLabel: 'Kvarteret',
        POLabel: 'Kvarter',
        POGLabel: 'Kvarter',
        PBLabel: 'Kvarteren',
        PBGLabel: 'Kvarteren',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kvarteret primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kvarteret versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kvarteret id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kvarteret fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KVARTER: {
          AttributeName: 'KVARTER',
          DisplayLabel: 'Kvarter',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;'], ['ConditionShowValuesFilter', '{KGard.KGARD} = #./KGard/KGARD#']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesFilter', '{KGard.KGARD} = #./KGard/KGARD#']]),
        },
        HasAvdelning: {
          AttributeName: 'HasAvdelning',
          DisplayLabel: 'Har avdelningar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SafeBenamning: {
          AttributeName: 'SafeBenamning',
          DisplayLabel: 'Benämning eller kod',
          Hint: 'Visar kod om benämning saknas',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        KGard: {
          AssociationName: 'KGard',
          DisplayLabel: 'KGard',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Kyrkogård, benämning",SafeBenamning="Kyrkogård, benämning eller kod",KodBenamning="Kyrkogård, kod och benämning",Intaktskonto="Kyrkogård, intäktskonto";']]),
        },
        Avdelningar: {
          AssociationName: 'Avdelningar',
          DisplayLabel: 'Avdelningar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAAvdelning',
          AssociatedComponentName: 'Avdelning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravar: {
          AssociationName: 'Gravar',
          DisplayLabel: 'Gravar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAKGard: {
      CollectionName: 'GAKGard',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['KBValue', '-19'], ['USER_DEF_REPORT_ROUTINE', '7'], ['AllowEdit', '2026']]),
      RootType: {
        TypeValue: 'KGard',
        Abstract: false,
        SOLabel: 'Kyrkogård',
        SOGLabel: 'Kyrkogård',
        SBLabel: 'Kyrkogården',
        SBGLabel: 'Kyrkogården',
        POLabel: 'Kyrkogårdar',
        POGLabel: 'Kyrkogårdar',
        PBLabel: 'Kyrkogårdarna',
        PBGLabel: 'Kyrkogårdarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kyrkogården primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kyrkogården versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kyrkogården id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kyrkogården fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KGARD: {
          AttributeName: 'KGARD',
          DisplayLabel: 'Kyrkogård',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 3,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        DISTRIKT_ID: {
          AttributeName: 'DISTRIKT_ID',
          DisplayLabel: 'Distrikt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'KBIntaktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['KBValue', '-19;']]),
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        HasKvarter: {
          AttributeName: 'HasKvarter',
          DisplayLabel: 'Har kvarter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Kod och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SafeBenamning: {
          AttributeName: 'SafeBenamning',
          DisplayLabel: 'Benämning eller kod',
          Hint: 'Visar kod om benämning saknas',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KBNollaSaldo: {
          AttributeName: 'KBNollaSaldo',
          DisplayLabel: 'KBNollaSaldo',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKGardBlob',
          AssociatedComponentName: 'KGardBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Distrikt: {
          AssociationName: 'Distrikt',
          DisplayLabel: 'Distrikt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GADistrikt',
          AssociatedComponentName: 'Distrikt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Distrikt, benämning";']]),
        },
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        NollaSaldo: {
          AssociationName: 'NollaSaldo',
          DisplayLabel: 'Konto för att justera saldo på avtal',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravar: {
          AssociationName: 'Gravar',
          DisplayLabel: 'Gravar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kvarter: {
          AssociationName: 'Kvarter',
          DisplayLabel: 'Kvarter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKvarter',
          AssociatedComponentName: 'Kvarter',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAKGardBlob: {
      CollectionName: 'GAKGardBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KGardBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GAKGardBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GAKGardBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'GAKGardBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GAKGardBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HTML_INFO: {
          AttributeName: 'HTML_INFO',
          DisplayLabel: 'Informationssida för Sv Gravar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LINK: {
          AttributeName: 'LINK',
          DisplayLabel: 'LINK',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAMall: {
      CollectionName: 'GAMall',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'Mall',
        Abstract: false,
        SOLabel: 'Mall',
        SOGLabel: 'Mall',
        SBLabel: 'Mallen',
        SBGLabel: 'Mallen',
        POLabel: 'Mallar',
        POGLabel: 'Mallar',
        PBLabel: 'Mallarna',
        PBGLabel: 'Mallarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Mallen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Mallen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Mallen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Mallen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Kistmall/Urnmall',
          DataType: 'Enum',
          EnumValues: new Map([['KISTMALL', 'Kistmall'], ['URNMALL', 'Urnmall']]),
          EnumSortValues: new Map([['KISTMALL', 'K'], ['URNMALL', 'U']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KISTMALL=Kistmall;URNMALL=Urnmall"',
          InterfaceType: 'ifChecklist',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        UTFORMNING: {
          AttributeName: 'UTFORMNING',
          DisplayLabel: 'Utformning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLATSNAMN: {
          AttributeName: 'PLATSNAMN',
          DisplayLabel: 'Platsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANVANDS: {
          AttributeName: 'ANVANDS',
          DisplayLabel: 'Används',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        GravMall: {
          AssociationName: 'GravMall',
          DisplayLabel: 'Gravmall',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Gravplats',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GravDjupK: {
          AssociationName: 'GravDjupK',
          DisplayLabel: 'GravDjup kistmall',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravDjup',
          AssociatedComponentName: 'GravDjup',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GravDjupU: {
          AssociationName: 'GravDjupU',
          DisplayLabel: 'GravDjup urnmall',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravDjup',
          AssociatedComponentName: 'GravDjup',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAHandelseMottagare: {
      CollectionName: 'GAHandelseMottagare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'HandelseMottagare',
        Abstract: false,
        SOLabel: 'Mottagare',
        SOGLabel: 'Mottagares',
        SBLabel: 'Mottagaren',
        SBGLabel: 'Mottagarens',
        POLabel: 'Mottagare',
        POGLabel: 'Mottagares',
        PBLabel: 'Mottagarna',
        PBGLabel: 'Mottagarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Mottagarens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Mottagarens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Mottagarens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Mottagarens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kontakt: {
          AssociationName: 'Kontakt',
          DisplayLabel: 'Kontakt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    GAInfokiosk: {
      CollectionName: 'GAInfokiosk',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Infokiosk',
        Abstract: false,
        SOLabel: 'Nyhet',
        SOGLabel: 'Nyhets',
        SBLabel: 'Nyheten',
        SBGLabel: 'Nyhetens',
        POLabel: 'Nyheter',
        POGLabel: 'Nyheters',
        PBLabel: 'Nyheterna',
        PBGLabel: 'Nyheternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Nyhetens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Nyhetens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Nyhetens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'Id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KGARD_ID: {
          AttributeName: 'KGARD_ID',
          DisplayLabel: 'Id, kyrkogård',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PUBLICERAS_FRAN: {
          AttributeName: 'PUBLICERAS_FRAN',
          DisplayLabel: 'Publiceras från',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PUBLICERAS_TILL: {
          AttributeName: 'PUBLICERAS_TILL',
          DisplayLabel: 'Publiceras till',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Text',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        KGard: {
          AssociationName: 'KGard',
          DisplayLabel: 'KGard',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['OverrideDisplayLabels', 'BENAMNING="Kyrkogård, benämning",SafeBenamning="Kyrkogård, benämning eller kod",KodBenamning="Kyrkogård, kod och benämning",Intaktskonto="Kyrkogård, intäktskonto";']]),
        },
      },
    },
    GAOrderOmg: {
      CollectionName: 'GAOrderOmg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrderOmg',
        Abstract: false,
        SOLabel: 'Orderomgång',
        SOGLabel: 'Orderomgång',
        SBLabel: 'Orderomgången',
        SBGLabel: 'Orderomgången',
        POLabel: 'Orderomgångar',
        POGLabel: 'Orderomgångar',
        PBLabel: 'Orderomgångarna',
        PBGLabel: 'Orderomgångarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Orderomgången primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Orderomgången versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Orderomgången id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Orderomgången fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_OMG: {
          AttributeName: 'ORDER_OMG',
          DisplayLabel: 'Orderomgång',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['EXPORTABLE_KEY', 'True;']]),
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['BACKAD', 'B']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;BACKAD=Backad"',
          InterfaceType: 'ifChecklist',
        },
        DATUM_SKAPAD: {
          AttributeName: 'DATUM_SKAPAD',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGN_SKAPAD: {
          AttributeName: 'SIGN_SKAPAD',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DATUM_BACKAD: {
          AttributeName: 'DATUM_BACKAD',
          DisplayLabel: 'Backad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SIGN_BACKAD: {
          AttributeName: 'SIGN_BACKAD',
          DisplayLabel: 'Backad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Status2: {
          AttributeName: 'Status2',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusBen: {
          AttributeName: 'StatusBen',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusText: {
          AttributeName: 'StatusText',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAOrderOmgBlob',
          AssociatedComponentName: 'OrderOmgBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Arsskotsel: {
          AssociationName: 'Arsskotsel',
          DisplayLabel: 'Årsskötsel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAOrderOmgSkotsel',
          AssociatedComponentName: 'OrderOmgSkotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAOrderOmgBlob: {
      CollectionName: 'GAOrderOmgBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrderOmgBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GAOrderOmgBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GAOrderOmgBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'GAOrderOmgBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GAOrderOmgBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        URVAL: {
          AttributeName: 'URVAL',
          DisplayLabel: 'Urval',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 200,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAGravHandelseRubrik: {
      CollectionName: 'GAGravHandelseRubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '48']]),
      RootType: {
        TypeValue: 'GravHandelseRubrik',
        Abstract: false,
        SOLabel: 'Rubrik',
        SOGLabel: 'Rubriks',
        SBLabel: 'Rubriken',
        SBGLabel: 'Rubrikens',
        POLabel: 'Rubriker',
        POGLabel: 'Rubrikers',
        PBLabel: 'Rubrikerna',
        PBGLabel: 'Rubrikernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rubrikens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rubrikens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rubrikens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rubrikens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GASkotselBest: {
      CollectionName: 'GASkotselBest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SkotselBest',
        Abstract: false,
        SOLabel: 'Skötselbeställning',
        SOGLabel: 'Skötselbeställnings',
        SBLabel: 'Skötselbeställningen',
        SBGLabel: 'Skötselbeställningens',
        POLabel: 'Skötselbeställningar',
        POGLabel: 'Skötselbeställningars',
        PBLabel: 'Skötselbeställningarna',
        PBGLabel: 'Skötselbeställningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skötselbeställningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skötselbeställningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skötselbeställningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAV_ID: {
          AttributeName: 'GRAV_ID',
          DisplayLabel: 'Id, Grav',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDERNUMMER: {
          AttributeName: 'ORDERNUMMER',
          DisplayLabel: 'Beställningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PERS_NR: {
          AttributeName: 'PERS_NR',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 150,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GATUADRESS: {
          AttributeName: 'GATUADRESS',
          DisplayLabel: 'Gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 150,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        POSTNR: {
          AttributeName: 'POSTNR',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORT: {
          AttributeName: 'ORT',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEL: {
          AttributeName: 'TEL',
          DisplayLabel: 'Telefonnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EPOST: {
          AttributeName: 'EPOST',
          DisplayLabel: 'Epost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 150,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESTALLNINGSTID: {
          AttributeName: 'BESTALLNINGSTID',
          DisplayLabel: 'Beställningstid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Mottagningsstatus',
          Hint: 'Ny/Mottagen/Refuserad',
          DataType: 'Enum',
          EnumValues: new Map([['NY', 'Ny'], ['MOTTAGEN', 'Mottagen'], ['REFUSERAD', 'Refuserad']]),
          EnumSortValues: new Map([['NY', 'N'], ['MOTTAGEN', 'M'], ['REFUSERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NY=Ny;MOTTAGEN=Mottagen;REFUSERAD=Refuserad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        SIGN: {
          AttributeName: 'SIGN',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MOTTAGNINGSTID: {
          AttributeName: 'MOTTAGNINGSTID',
          DisplayLabel: 'Behandlad den',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
        },
        BestallningsDatum: {
          AttributeName: 'BestallningsDatum',
          DisplayLabel: 'Beställningstid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MottagningsDatum: {
          AttributeName: 'MottagningsDatum',
          DisplayLabel: 'Behandlad den',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MEDDELANDE: {
          AttributeName: 'MEDDELANDE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifNone',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'GravplatsAktuell',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Artiklar: {
          AssociationName: 'Artiklar',
          DisplayLabel: 'Artiklar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotselBestArtikel',
          AssociatedComponentName: 'SkotselBestArtikel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        GravKontakter: {
          AssociationName: 'GravKontakter',
          DisplayLabel: 'Kontakter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GravSkotslar: {
          AssociationName: 'GravSkotslar',
          DisplayLabel: 'Skotslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GASkotselBestArtikel: {
      CollectionName: 'GASkotselBestArtikel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SkotselBestArtikel',
        Abstract: false,
        SOLabel: 'Skötselbeställningsartikel',
        SOGLabel: 'Skötselbeställningsartikels',
        SBLabel: 'Skötselbeställningsartikeln',
        SBGLabel: 'Skötselbeställningsartikelns',
        POLabel: 'Skötselbeställningsartiklar',
        POGLabel: 'Skötselbeställningsartiklars',
        PBLabel: 'Skötselbeställningsartiklarna',
        PBGLabel: 'Skötselbeställningsartiklarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skötselbeställningsartikelns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skötselbeställningsartikelns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skötselbeställningsartikelns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Id, artikel',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PRIS: {
          AttributeName: 'PRIS',
          DisplayLabel: 'Pris',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESTALLNING_ID: {
          AttributeName: 'BESTALLNING_ID',
          DisplayLabel: 'Beställnings id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    GASkotselKategoriArtikel: {
      CollectionName: 'GASkotselKategoriArtikel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SkotselKategoriArtikel',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'GASkotselKategoriArtikels primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'GASkotselKategoriArtikels versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'GASkotselKategoriArtikels fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORIID: {
          AttributeName: 'KATEGORIID',
          DisplayLabel: 'KategoriID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKELID: {
          AttributeName: 'ARTIKELID',
          DisplayLabel: 'ArtikelID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTERINGSORDNING: {
          AttributeName: 'SORTERINGSORDNING',
          DisplayLabel: 'SorteringsOrdning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Visningsnamn: {
          AttributeName: 'Visningsnamn',
          DisplayLabel: 'Visningsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Visningspris: {
          AttributeName: 'Visningspris',
          DisplayLabel: 'Visningspris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
        },
      },
    },
    GASkotList: {
      CollectionName: 'GASkotList',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'SkotList',
        Abstract: false,
        SOLabel: 'Skötsellista',
        SOGLabel: 'Skötsellista',
        SBLabel: 'Skötsellistan',
        SBGLabel: 'Skötsellistan',
        POLabel: 'Skötsellistor',
        POGLabel: 'Skötsellistor',
        PBLabel: 'Skötsellistorna',
        PBGLabel: 'Skötsellistorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skötsellistan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skötsellistan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Skötsellistan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skötsellistan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Skötselstatistik',
          DataType: 'Enum',
          EnumValues: new Map([['SKOTSELSTATISTIK', 'Skötselstatistik']]),
          EnumSortValues: new Map([['SKOTSELSTATISTIK', 'S']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKOTSELSTATISTIK=Skötselstatistik"',
          GUIEditable: true,
        },
        INST: {
          AttributeName: 'INST',
          DisplayLabel: 'Egenskaper',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISA_INST: {
          AttributeName: 'VISA_INST',
          DisplayLabel: 'Visa kod/benämning',
          Hint: 'Fullständig benämning/Endast benämning/Endast kod',
          DataType: 'Enum',
          EnumValues: new Map([['FULLSTANDIG_BENAMNING', 'Fullständig benämning'], ['ENDAST_BENAMNING', 'Endast benämning'], ['ENDAST_KOD', 'Endast kod']]),
          EnumSortValues: new Map([['FULLSTANDIG_BENAMNING', 'F'], ['ENDAST_BENAMNING', 'B'], ['ENDAST_KOD', 'K']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FULLSTANDIG_BENAMNING=Fullständig benämning;ENDAST_BENAMNING=Endast benämning;ENDAST_KOD=Endast kod"',
        },
        GRUPP1_TYP: {
          AttributeName: 'GRUPP1_TYP',
          DisplayLabel: 'Grupperingsbegrepp 1',
          Hint: 'Kyrkogård/Kvarter/Avdelning/Artikelgrupp/Artikelsortiment/Artikel',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKOGARD', 'Kyrkogård'], ['KVARTER', 'Kvarter'], ['AVDELNING', 'Avdelning'], ['ARTIKELGRUPP', 'Artikelgrupp'], ['ARTIKELSORTIMENT', 'Artikelsortiment'], ['ARTIKEL', 'Artikel']]),
          EnumSortValues: new Map([['KYRKOGARD', 'K'], ['KVARTER', 'V'], ['AVDELNING', 'D'], ['ARTIKELGRUPP', 'G'], ['ARTIKELSORTIMENT', 'S'], ['ARTIKEL', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKOGARD=Kyrkogård;KVARTER=Kvarter;AVDELNING=Avdelning;ARTIKELGRUPP=Artikelgrupp;ARTIKELSORTIMENT=Artikelsortiment;ARTIKEL=Artikel"',
        },
        GRUPP1_INST: {
          AttributeName: 'GRUPP1_INST',
          DisplayLabel: 'Grupperingsbegrepp 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP2_TYP: {
          AttributeName: 'GRUPP2_TYP',
          DisplayLabel: 'Grupperingsbegrepp 2',
          Hint: 'Kyrkogård/Kvarter/Avdelning/Artikelgrupp/Artikelsortiment/Artikel',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKOGARD', 'Kyrkogård'], ['KVARTER', 'Kvarter'], ['AVDELNING', 'Avdelning'], ['ARTIKELGRUPP', 'Artikelgrupp'], ['ARTIKELSORTIMENT', 'Artikelsortiment'], ['ARTIKEL', 'Artikel']]),
          EnumSortValues: new Map([['KYRKOGARD', 'K'], ['KVARTER', 'V'], ['AVDELNING', 'D'], ['ARTIKELGRUPP', 'G'], ['ARTIKELSORTIMENT', 'S'], ['ARTIKEL', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKOGARD=Kyrkogård;KVARTER=Kvarter;AVDELNING=Avdelning;ARTIKELGRUPP=Artikelgrupp;ARTIKELSORTIMENT=Artikelsortiment;ARTIKEL=Artikel"',
        },
        GRUPP2_INST: {
          AttributeName: 'GRUPP2_INST',
          DisplayLabel: 'Grupperingsbegrepp 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP3_TYP: {
          AttributeName: 'GRUPP3_TYP',
          DisplayLabel: 'Grupperingsbegrepp 3',
          Hint: 'Kyrkogård/Kvarter/Avdelning/Artikelgrupp/Artikelsortiment/Artikel',
          DataType: 'Enum',
          EnumValues: new Map([['KYRKOGARD', 'Kyrkogård'], ['KVARTER', 'Kvarter'], ['AVDELNING', 'Avdelning'], ['ARTIKELGRUPP', 'Artikelgrupp'], ['ARTIKELSORTIMENT', 'Artikelsortiment'], ['ARTIKEL', 'Artikel']]),
          EnumSortValues: new Map([['KYRKOGARD', 'K'], ['KVARTER', 'V'], ['AVDELNING', 'D'], ['ARTIKELGRUPP', 'G'], ['ARTIKELSORTIMENT', 'S'], ['ARTIKEL', 'A']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KYRKOGARD=Kyrkogård;KVARTER=Kvarter;AVDELNING=Avdelning;ARTIKELGRUPP=Artikelgrupp;ARTIKELSORTIMENT=Artikelsortiment;ARTIKEL=Artikel"',
        },
        GRUPP3_INST: {
          AttributeName: 'GRUPP3_INST',
          DisplayLabel: 'Grupperingsbegrepp 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kolumner: {
          AssociationName: 'Kolumner',
          DisplayLabel: 'Kolumner',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GASkotListKol',
          AssociatedComponentName: 'SkotListKol',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    GASkotsel: {
      CollectionName: 'GASkotsel',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '30'], ['BLANKETT_GRAVPLATS_BASE', 'Grav']]),
      RootType: {
        TypeValue: 'Skotsel',
        Abstract: false,
        SOLabel: 'Skötsel',
        SOGLabel: 'Skötsel',
        SBLabel: 'Skötseln',
        SBGLabel: 'Skötseln',
        POLabel: 'Skötslar',
        POGLabel: 'Skötslar',
        PBLabel: 'Skötslarna',
        PBGLabel: 'Skötslarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Skötseln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Skötseln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Skötseln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Skötseln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR_FR: {
          AttributeName: 'AR_FR',
          DisplayLabel: 'År från',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          FormatterParseParams: 'CenturyLimit="90"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AR_TI: {
          AttributeName: 'AR_TI',
          DisplayLabel: 'År till',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          FormatterParseParams: 'CenturyLimit="90"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AR_INTERVALL: {
          AttributeName: 'AR_INTERVALL',
          DisplayLabel: 'Årsintervall',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="2";MaxValue="10"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUMKOD: {
          AttributeName: 'DATUMKOD',
          DisplayLabel: 'Datumkod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="12"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DAG: {
          AttributeName: 'DAG',
          DisplayLabel: 'Dag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FAKT_OMG: {
          AttributeName: 'FAKT_OMG',
          DisplayLabel: 'Faktureringsomgång',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        UTSKRIFT_PL: {
          AttributeName: 'UTSKRIFT_PL',
          DisplayLabel: 'Skriv ut på arbetsunderlag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
        },
        BELOPP: {
          AttributeName: 'BELOPP',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        DEB_SATT: {
          AttributeName: 'DEB_SATT',
          DisplayLabel: 'Debiteringssätt',
          Hint: 'Ej skuldfört avtal/Debiteras/Debiteras ej',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_SKULDFORT_AVTAL', 'Ej skuldfört avtal'], ['DEBITERAS', 'Debiteras'], ['DEBITERAS_EJ', 'Debiteras ej']]),
          EnumSortValues: new Map([['EJ_SKULDFORT_AVTAL', 'A'], ['DEBITERAS', 'D'], ['DEBITERAS_EJ', 'E']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_SKULDFORT_AVTAL=Ej skuldfört avtal;DEBITERAS=Debiteras;DEBITERAS_EJ=Debiteras ej"',
        },
        PAKET: {
          AttributeName: 'PAKET',
          DisplayLabel: 'Paket',
          Hint: 'Paket/Ingår i paket',
          DataType: 'Enum',
          EnumValues: new Map([['PAKET', 'Paket'], ['INGAR_I_PAKET', 'Ingår i paket']]),
          EnumSortValues: new Map([['PAKET', 'P'], ['INGAR_I_PAKET', 'I']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PAKET=Paket;INGAR_I_PAKET=Ingår i paket"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        PAKET_ID: {
          AttributeName: 'PAKET_ID',
          DisplayLabel: 'Paket',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PAKET_LOPNR: {
          AttributeName: 'PAKET_LOPNR',
          DisplayLabel: 'Paket',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVTAL_ID: {
          AttributeName: 'AVTAL_ID',
          DisplayLabel: 'Avtal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVTAL_LOPNR: {
          AttributeName: 'AVTAL_LOPNR',
          DisplayLabel: 'Avtal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_ID: {
          AttributeName: 'KONTAKT_ID',
          DisplayLabel: 'Kontakt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_LOPNR: {
          AttributeName: 'KONTAKT_LOPNR',
          DisplayLabel: 'Kontakt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTGRUPP_ID: {
          AttributeName: 'FAKTGRUPP_ID',
          DisplayLabel: 'Faktureringsgrupp, id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLNINGSDATUM: {
          AttributeName: 'BESTALLNINGSDATUM',
          DisplayLabel: 'Beställningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AR_TI_OLD: {
          AttributeName: 'AR_TI_OLD',
          DisplayLabel: 'År t.o.m. innan återl/återt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING_ARBETSUNDERLAG: {
          AttributeName: 'NOTERING_ARBETSUNDERLAG',
          DisplayLabel: 'Notering på arbetsunderlag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        NOTERING_FAKTURA: {
          AttributeName: 'NOTERING_FAKTURA',
          DisplayLabel: 'Notering på faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Ar: {
          AttributeName: 'Ar',
          DisplayLabel: 'År',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArtikelAnvPris: {
          AttributeName: 'ArtikelAnvPris',
          DisplayLabel: 'Använd artikels prislista',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningStr: {
          AttributeName: 'BenamningStr',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Kort benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Debsatt: {
          AttributeName: 'Debsatt',
          DisplayLabel: 'Debiteringssätt',
          Hint: 'Faktura/Bankkonto/Autogiro/Avräkningsavtal/Fasttidsavtal/Allframtidsavtal/Ej skuldfört avtal/Debiteras ej',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['BANKKONTO', 'Bankkonto'], ['AUTOGIRO', 'Autogiro'], ['AVRAKNINGSAVTAL', 'Avräkningsavtal'], ['FASTTIDSAVTAL', 'Fasttidsavtal'], ['ALLFRAMTIDSAVTAL', 'Allframtidsavtal'], ['EJ_SKULDFORT_AVTAL', 'Ej skuldfört avtal'], ['DEBITERAS_EJ', 'Debiteras ej']]),
          EnumSortValues: new Map([['FAKTURA', 'DF'], ['BANKKONTO', 'DB'], ['AUTOGIRO', 'DU'], ['AVRAKNINGSAVTAL', 'DK'], ['FASTTIDSAVTAL', 'DA'], ['ALLFRAMTIDSAVTAL', 'AA'], ['EJ_SKULDFORT_AVTAL', 'AG'], ['DEBITERAS_EJ', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;BANKKONTO=Bankkonto;AUTOGIRO=Autogiro;AVRAKNINGSAVTAL=Avräkningsavtal;FASTTIDSAVTAL=Fasttidsavtal;ALLFRAMTIDSAVTAL=Allframtidsavtal;EJ_SKULDFORT_AVTAL=Ej skuldfört avtal;DEBITERAS_EJ=Debiteras ej"',
          InterfaceType: 'ifChecklist',
        },
        DebsattNr: {
          AttributeName: 'DebsattNr',
          DisplayLabel: 'Debiteringssätt och kund/avtal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DebsattNrNamn: {
          AttributeName: 'DebsattNrNamn',
          DisplayLabel: 'Debiteringssätt, kund/avtal och namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Debsatt2NrNamnFE: {
          AttributeName: 'Debsatt2NrNamnFE',
          DisplayLabel: 'Debiteringssätt, kund/avtal och namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DebsattKod: {
          AttributeName: 'DebsattKod',
          DisplayLabel: 'Debiteringssätt, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DebsattPaket: {
          AttributeName: 'DebsattPaket',
          DisplayLabel: 'Debiteringssätt, paket eller kund/avtal och namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PaketInfo: {
          AttributeName: 'PaketInfo',
          DisplayLabel: 'Ingår i paket',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Kundtyp: {
          AttributeName: 'Kundtyp',
          DisplayLabel: 'Kundtyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoSaldoAktuellt: {
          AttributeName: 'KontoSaldoAktuellt',
          DisplayLabel: 'Kontosaldo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KontaktBorttagen: {
          AttributeName: 'KontaktBorttagen',
          DisplayLabel: 'Betalningsansvarig borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AvtalBorttaget: {
          AttributeName: 'AvtalBorttaget',
          DisplayLabel: 'Avtal borttaget',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RefBorttagen: {
          AttributeName: 'RefBorttagen',
          DisplayLabel: 'Kund/avtal borttaget',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EnhetAntalDec: {
          AttributeName: 'EnhetAntalDec',
          DisplayLabel: 'Antal decimaler',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalEnhet: {
          AttributeName: 'AntalEnhet',
          DisplayLabel: 'Antal och enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AntalSQL: {
          AttributeName: 'AntalSQL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Moms: {
          AttributeName: 'Moms',
          DisplayLabel: 'Moms',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PrisSQL: {
          AttributeName: 'PrisSQL',
          DisplayLabel: 'À-pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeParams: {'PrisPerDatum': {type: 'String', defaultValue: ''}},
        },
        BeloppSQL: {
          AttributeName: 'BeloppSQL',
          DisplayLabel: 'Belopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeParams: {'PrisPerDatum': {type: 'String', defaultValue: ''}},
        },
        BeloppMomsSQL: {
          AttributeName: 'BeloppMomsSQL',
          DisplayLabel: 'Belopp inkl moms',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeParams: {'PrisPerDatum': {type: 'String', defaultValue: ''}},
        },
        GravKannetecken: {
          AttributeName: 'GravKannetecken',
          DisplayLabel: 'Grav kännetecken',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravUplStatus: {
          AttributeName: 'GravUplStatus',
          DisplayLabel: 'Grav upplåtelsestatus',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravUplStatusLabel: {
          AttributeName: 'GravUplStatusLabel',
          DisplayLabel: 'Grav upplåtelsestatus',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravGravplatsID: {
          AttributeName: 'GravGravplatsID',
          DisplayLabel: 'GravplatsID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BegrVerksamhet: {
          AttributeName: 'BegrVerksamhet',
          DisplayLabel: 'Begravningsverksamheten',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        DebiteradTom: {
          AttributeName: 'DebiteradTom',
          DisplayLabel: 'Debiterad t.o.m.',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ArbUndTom: {
          AttributeName: 'ArbUndTom',
          DisplayLabel: 'Arbetsunderlag skapat t.o.m.',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SortAr: {
          AttributeName: 'SortAr',
          DisplayLabel: 'År',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FaktureradGrupp: {
          AttributeName: 'FaktureradGrupp',
          DisplayLabel: 'Fakturerad i år på grupp',
          DataType: 'Int',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifChecklist',
        },
        IngarIPaket: {
          AttributeName: 'IngarIPaket',
          DisplayLabel: 'Ingår i paket (J/N)',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        ValidAr: {
          AttributeName: 'ValidAr',
          DisplayLabel: 'Gäller år',
          DataType: 'Int',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          FormatterParseParams: 'CenturyLimit="+90"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        PrisMomsSQL: {
          AttributeName: 'PrisMomsSQL',
          DisplayLabel: 'Pris inkl moms',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeParams: {'PrisPerDatum': {type: 'String', defaultValue: ''}},
        },
        PrisPerEnhetSQL: {
          AttributeName: 'PrisPerEnhetSQL',
          DisplayLabel: 'Pris per enhet',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'PrisPerDatum': {type: 'String', defaultValue: ''}},
        },
        SkotselPerAr: {
          AttributeName: 'SkotselPerAr',
          DisplayLabel: 'Skötsel per år, parameter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'SkotselPerAr': {type: 'String', defaultValue: ''}},
        },
        KlarForUtskr: {
          AttributeName: 'KlarForUtskr',
          DisplayLabel: 'Klar för utskrift arb.und',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeParams: {'SkotselPerAr': {type: 'String', defaultValue: ''}},
        },
        WEB_BEST: {
          AttributeName: 'WEB_BEST',
          DisplayLabel: 'Web beställd',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ArbUndStatus: {
          AttributeName: 'ArbUndStatus',
          DisplayLabel: 'Klara för arbetsunderlag',
          Hint: 'Utskrivet/Skapat/Ej på arb. und./Ej Aktuell/Ej fakturerad/Klar för utskrift/Ej betald',
          DataType: 'Enum',
          EnumValues: new Map([['UTSKRIVET', 'Utskrivet'], ['SKAPAT', 'Skapat'], ['EJ_PA_ARB__UND_', 'Ej på arb. und.'], ['EJ_AKTUELL', 'Ej Aktuell'], ['EJ_FAKTURERAD', 'Ej fakturerad'], ['KLAR_FOR_UTSKRIFT', 'Klar för utskrift'], ['EJ_BETALD', 'Ej betald']]),
          EnumSortValues: new Map([['UTSKRIVET', 'B'], ['SKAPAT', 'C'], ['EJ_PA_ARB__UND_', 'D'], ['EJ_AKTUELL', 'E'], ['EJ_FAKTURERAD', 'F'], ['KLAR_FOR_UTSKRIFT', 'G'], ['EJ_BETALD', 'H']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="UTSKRIVET=Utskrivet;SKAPAT=Skapat;EJ_PA_ARB__UND_=Ej på arb. und.;EJ_AKTUELL=Ej Aktuell;EJ_FAKTURERAD=Ej fakturerad;KLAR_FOR_UTSKRIFT=Klar för utskrift;EJ_BETALD=Ej betald"',
          InterfaceType: 'ifChecklist',
          AttributeParams: {'SkotselPerAr': {type: 'String', defaultValue: ''}},
        },
        Efakt: {
          AttributeName: 'Efakt',
          DisplayLabel: 'Använder E-faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifChecklist',
        },
        EfaktO: {
          AttributeName: 'EfaktO',
          DisplayLabel: 'Använder E-faktura företag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifChecklist',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Grav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avtal: {
          AssociationName: 'Avtal',
          DisplayLabel: 'Gamla avtal',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAAvtal',
          AssociatedComponentName: 'GammaltAvtal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontakt: {
          AssociationName: 'Kontakt',
          DisplayLabel: 'Betalningsansvarig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKontakt',
          AssociatedComponentName: 'Betalningsansvarig',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Avvikande faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Paket: {
          AssociationName: 'Paket',
          DisplayLabel: 'Paket',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ArsskotselOrderPerAr: {
          AssociationName: 'ArsskotselOrderPerAr',
          DisplayLabel: 'Årsskötsel order per år',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAOrderOmgSkotsel',
          AssociatedComponentName: 'OrderOmgSkotsel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomJoin', '{Alias.SKOTSEL_ID} = {FromAlias.GRAV_ID} and {Alias.SKOTSEL_LOPNR} = {FromAlias.LOPNR} and {Alias.AR} = :SkotselPerAr and {Alias.STATUS} = \'S\'']]),
        },
        ArsskotselArbUndPerAr: {
          AssociationName: 'ArsskotselArbUndPerAr',
          DisplayLabel: 'Årsskötsel arbetsunderlag per år',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAArbUndSkotsel',
          AssociatedComponentName: 'ArbUndSkotsel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ArsskotselOrder: {
          AssociationName: 'ArsskotselOrder',
          DisplayLabel: 'Årsskötsel order',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAOrderOmgSkotsel',
          AssociatedComponentName: 'OrderOmgSkotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.SKOTSEL_ID} = {FromAlias.GRAV_ID} and {Alias.SKOTSEL_LOPNR} = {FromAlias.LOPNR} and {Alias.STATUS} = \'S\'']]),
        },
        ArsskotselArbUnd: {
          AssociationName: 'ArsskotselArbUnd',
          DisplayLabel: 'Årsskötsel arbetsunderlag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAArbUndSkotsel',
          AssociatedComponentName: 'ArbUndSkotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        PaketSkotslar: {
          AssociationName: 'PaketSkotslar',
          DisplayLabel: 'Skötslar i paketet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        PaketArtiklar: {
          AssociationName: 'PaketArtiklar',
          DisplayLabel: 'Artiklar i paketet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikelPaket',
          AssociatedComponentName: 'ArtikelPaket',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAGravGravStatus: {
      CollectionName: 'GAGravGravStatus',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravGravStatus',
        Abstract: false,
        SOLabel: 'Statuskod',
        SOGLabel: 'Statuskod',
        SBLabel: 'Statuskoden',
        SBGLabel: 'Statuskoden',
        POLabel: 'Statuskoder',
        POGLabel: 'Statuskoder',
        PBLabel: 'Statuskoderna',
        PBGLabel: 'Statuskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Statuskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Statuskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Statuskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Statuskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesSubsystem', 'GA;'], ['ConditionShowValuesCollection', 'TEDGAGravStatusSaml;'], ['ConditionShowValuesAttribute', 'STATUS;']]),
        },
        Benamning: {
          AttributeName: 'Benamning',
          DisplayLabel: 'Benämning',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Grav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Status: {
          AssociationName: 'Status',
          DisplayLabel: 'Status',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGravStatus',
          AssociatedComponentName: 'GravStatus',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    GAGravStatus: {
      CollectionName: 'GAGravStatus',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravStatus',
        Abstract: false,
        SOLabel: 'Statuskod',
        SOGLabel: 'Statuskod',
        SBLabel: 'Statuskoden',
        SBGLabel: 'Statuskoden',
        POLabel: 'Statuskoder',
        POGLabel: 'Statuskoder',
        PBLabel: 'Statuskoderna',
        PBGLabel: 'Statuskoderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Statuskoden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Statuskoden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Statuskoden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Statuskoden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    GAGravKontroll: {
      CollectionName: 'GAGravKontroll',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GravKontroll',
        Abstract: false,
        SOLabel: 'Stenkontroll',
        SOGLabel: 'Stenkontrolls',
        SBLabel: 'Stenkontrollen',
        SBGLabel: 'Stenkontrollens',
        POLabel: 'Stenkontroller',
        POGLabel: 'Stenkontrollers',
        PBLabel: 'Stenkontrollerna',
        PBGLabel: 'Stenkontrollernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Stenkontrollens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Stenkontrollens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Stenkontrollens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Stenkontrollens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Inventeringsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Godkänd/Stöttad/Nedlagd/Ej åtgärdad/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['GODKAND', 'Godkänd'], ['STOTTAD', 'Stöttad'], ['NEDLAGD', 'Nedlagd'], ['EJ_ATGARDAD', 'Ej åtgärdad'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['GODKAND', 'G'], ['STOTTAD', 'S'], ['NEDLAGD', 'N'], ['EJ_ATGARDAD', 'E'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GODKAND=Godkänd;STOTTAD=Stöttad;NEDLAGD=Nedlagd;EJ_ATGARDAD=Ej åtgärdad;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LUTNING: {
          AttributeName: 'LUTNING',
          DisplayLabel: 'Lutning i grader',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsDegrees',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Anteckningar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenasteStenkontroll: {
          AttributeName: 'SenasteStenkontroll',
          DisplayLabel: 'Senaste stenkontroll',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ANMARKNINGAR: {
          AttributeName: 'ANMARKNINGAR',
          DisplayLabel: 'Anmärkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesSubsystem', 'GA;'], ['ConditionShowValuesCollection', 'TEDGAGravAnmarkningSaml;'], ['ConditionShowValuesAttribute', 'BENAMNING;']]),
        },
        BILD_ID: {
          AttributeName: 'BILD_ID',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Grav',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Begravningsplats',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bild: {
          AssociationName: 'Bild',
          DisplayLabel: 'Bild',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravBlob',
          AssociatedComponentName: 'GravBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anordning: {
          AssociationName: 'Anordning',
          DisplayLabel: 'Anordning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravanordning',
          AssociatedComponentName: 'Gravanordning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAKartaTema: {
      CollectionName: 'GAKartaTema',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KartaTema',
        Abstract: false,
        SOLabel: 'Tema',
        SOGLabel: 'Temas',
        SBLabel: 'Temat',
        SBGLabel: 'Temats',
        POLabel: 'Teman',
        POGLabel: 'Temans',
        PBLabel: 'Teman',
        PBGLabel: 'Temans',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Temats primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Temats versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Temats id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Temats fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SELECTION_ID: {
          AttributeName: 'SELECTION_ID',
          DisplayLabel: 'Urval',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SQLJOIN: {
          AttributeName: 'SQLJOIN',
          DisplayLabel: 'Join-SQL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SQLWHERE: {
          AttributeName: 'SQLWHERE',
          DisplayLabel: 'Where-SQL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SQLDATE: {
          AttributeName: 'SQLDATE',
          DisplayLabel: 'Tema skapat datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.less,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Selection: {
          AssociationName: 'Selection',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAMyCartaUrval: {
      CollectionName: 'GAMyCartaUrval',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'MyCartaUrval',
        Abstract: false,
        SOLabel: 'Urval',
        SOGLabel: 'Urvals',
        SBLabel: 'Urvalet',
        SBGLabel: 'Urvalets',
        POLabel: 'Urval',
        POGLabel: 'Urvals',
        PBLabel: 'Urvalen',
        PBGLabel: 'Urvalens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Urvalets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Urvalets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Urvalets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Urvalets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.starts,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SELECTION_ID: {
          AttributeName: 'SELECTION_ID',
          DisplayLabel: 'Urval',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FARG: {
          AttributeName: 'FARG',
          DisplayLabel: 'Färg',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SQLDATE: {
          AttributeName: 'SQLDATE',
          DisplayLabel: 'Urval senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.less,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Selection: {
          AssociationName: 'Selection',
          DisplayLabel: 'Urval',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUrval',
          AssociatedComponentName: 'Urval',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAVanvard: {
      CollectionName: 'GAVanvard',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Vanvard',
        Abstract: false,
        SOLabel: 'Vanvårdsmarkering',
        SOGLabel: 'Vanvårdsmarkerings',
        SBLabel: 'Vanvårdsmarkeringen',
        SBGLabel: 'Vanvårdsmarkeringens',
        POLabel: 'Vanvårdsmarkeringar',
        POGLabel: 'Vanvårdsmarkeringars',
        PBLabel: 'Vanvårdsmarkeringarna',
        PBGLabel: 'Vanvårdsmarkeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Vanvårdsmarkeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Vanvårdsmarkeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Vanvårdsmarkeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAV_ID: {
          AttributeName: 'GRAV_ID',
          DisplayLabel: 'Id, Grav',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VANVARDSMARKERING: {
          AttributeName: 'VANVARDSMARKERING',
          DisplayLabel: 'Vanvårdsmarkering',
          Hint: 'Vanvård 1/Vanvård 2/Vanvård 3/Gravrätten Förverkad/Godkänd',
          DataType: 'Enum',
          EnumValues: new Map([['VANVARD_1', 'Vanvård 1'], ['VANVARD_2', 'Vanvård 2'], ['VANVARD_3', 'Vanvård 3'], ['GRAVRATTEN_FORVERKAD', 'Gravrätten Förverkad'], ['GODKAND', 'Godkänd']]),
          EnumSortValues: new Map([['VANVARD_1', '1'], ['VANVARD_2', '2'], ['VANVARD_3', '3'], ['GRAVRATTEN_FORVERKAD', 'F'], ['GODKAND', 'G']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VANVARD_1=Vanvård 1;VANVARD_2=Vanvård 2;VANVARD_3=Vanvård 3;GRAVRATTEN_FORVERKAD=Gravrätten Förverkad;GODKAND=Godkänd"',
        },
        BESLUTSDATUM: {
          AttributeName: 'BESLUTSDATUM',
          DisplayLabel: 'Beslutsdatum förverkad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DIARIENUMMER: {
          AttributeName: 'DIARIENUMMER',
          DisplayLabel: 'Diarienummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Godkand: {
          AttributeName: 'Godkand',
          DisplayLabel: 'Godkänd vanvård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        LastLopnr: {
          AttributeName: 'LastLopnr',
          DisplayLabel: 'Godkänd/Förverkad vanvård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        LastMarkering: {
          AttributeName: 'LastMarkering',
          DisplayLabel: 'Senaste vanvårdsmarkering',
          Hint: 'Vanvård År 1/Vanvård År 2/Vanvård År 3/Gravrätten Förverkad/Godkänd',
          DataType: 'Enum',
          EnumValues: new Map([['VANVARD_AR_1', 'Vanvård År 1'], ['VANVARD_AR_2', 'Vanvård År 2'], ['VANVARD_AR_3', 'Vanvård År 3'], ['GRAVRATTEN_FORVERKAD', 'Gravrätten Förverkad'], ['GODKAND', 'Godkänd']]),
          EnumSortValues: new Map([['VANVARD_AR_1', '1'], ['VANVARD_AR_2', '2'], ['VANVARD_AR_3', '3'], ['GRAVRATTEN_FORVERKAD', 'F'], ['GODKAND', 'G']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VANVARD_AR_1=Vanvård År 1;VANVARD_AR_2=Vanvård År 2;VANVARD_AR_3=Vanvård År 3;GRAVRATTEN_FORVERKAD=Gravrätten Förverkad;GODKAND=Godkänd"',
        },
        BESIKTNINGSDATUM: {
          AttributeName: 'BESIKTNINGSDATUM',
          DisplayLabel: 'Besiktningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+0d"',
          GUIEditable: true,
        },
        SistaBesiktning: {
          AttributeName: 'SistaBesiktning',
          DisplayLabel: 'Senaste besiktningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        BILD_ID: {
          AttributeName: 'BILD_ID',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Delgivningsdatum: {
          AttributeName: 'Delgivningsdatum',
          DisplayLabel: 'Delgivningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Grav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bild: {
          AssociationName: 'Bild',
          DisplayLabel: 'Bild',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGravBlob',
          AssociatedComponentName: 'GravBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAOrderOmgSkotsel: {
      CollectionName: 'GAOrderOmgSkotsel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'OrderOmgSkotsel',
        Abstract: false,
        SOLabel: 'Årsskötsel',
        SOGLabel: 'Årsskötsel',
        SBLabel: 'Årsskötseln',
        SBGLabel: 'Årsskötseln',
        POLabel: 'Årsskötslar',
        POGLabel: 'Årsskötslar',
        PBLabel: 'Årsskötslarna',
        PBGLabel: 'Årsskötslarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Årsskötseln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Årsskötseln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Årsskötseln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Årsskötseln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_ID: {
          AttributeName: 'ORDER_ID',
          DisplayLabel: 'Orderrad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_RADNR: {
          AttributeName: 'ORDER_RADNR',
          DisplayLabel: 'Orderrad',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ORDERNR: {
          AttributeName: 'ORDERNR',
          DisplayLabel: 'Ordernummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SKOTSEL_ID: {
          AttributeName: 'SKOTSEL_ID',
          DisplayLabel: 'Skötsel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKOTSEL_LOPNR: {
          AttributeName: 'SKOTSEL_LOPNR',
          DisplayLabel: 'Skötsel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVNR: {
          AttributeName: 'GRAVNR',
          DisplayLabel: 'Gravplatsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 35,
        },
        AR: {
          AttributeName: 'AR',
          DisplayLabel: 'År',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUMKOD: {
          AttributeName: 'DATUMKOD',
          DisplayLabel: 'Datumkod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="12"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DAG: {
          AttributeName: 'DAG',
          DisplayLabel: 'Dag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="99"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ARTIKELNR: {
          AttributeName: 'ARTIKELNR',
          DisplayLabel: 'Artikel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTALENHET: {
          AttributeName: 'ANTALENHET',
          DisplayLabel: 'Antal och enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEB_SATT: {
          AttributeName: 'DEB_SATT',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Skapad/Krediterad/Backad',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['KREDITERAD', 'Krediterad'], ['BACKAD', 'Backad']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['KREDITERAD', 'K'], ['BACKAD', 'B']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;KREDITERAD=Krediterad;BACKAD=Backad"',
        },
        URSP_AR_TI: {
          AttributeName: 'URSP_AR_TI',
          DisplayLabel: 'Ursprungligt år t.o.m. (backning)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PAKET: {
          AttributeName: 'PAKET',
          DisplayLabel: 'Paket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PAKET_INFO: {
          AttributeName: 'PAKET_INFO',
          DisplayLabel: 'Paket',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        Kvarter: {
          AttributeName: 'Kvarter',
          DisplayLabel: 'Benämning kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Gravnummer: {
          AttributeName: 'Gravnummer',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SkotselArtikelnr: {
          AttributeName: 'SkotselArtikelnr',
          DisplayLabel: 'Artikel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SkotselBenamning: {
          AttributeName: 'SkotselBenamning',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Kort benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Ordertyp: {
          AttributeName: 'Ordertyp',
          DisplayLabel: 'Ordertyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kund: {
          AttributeName: 'Kund',
          DisplayLabel: 'Kundnr/Avtalsnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Fakturadatum: {
          AttributeName: 'Fakturadatum',
          DisplayLabel: 'Fakturadatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Grupp: {
          AttributeName: 'Grupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Betald: {
          AttributeName: 'Betald',
          DisplayLabel: 'Betald',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        BetaldStr: {
          AttributeName: 'BetaldStr',
          DisplayLabel: 'Betald',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        StatusBen: {
          AttributeName: 'StatusBen',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Faktureringssatt: {
          AttributeName: 'Faktureringssatt',
          DisplayLabel: 'Faktureringssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bestallningsorder: {
          AttributeName: 'Bestallningsorder',
          DisplayLabel: 'Beställningsorder',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FaktAntal: {
          AttributeName: 'FaktAntal',
          DisplayLabel: 'FaktAntal',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
        },
        BestorderAntalEnhet: {
          AttributeName: 'BestorderAntalEnhet',
          DisplayLabel: 'BestOrderAntalEnhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalEnhet2: {
          AttributeName: 'AntalEnhet2',
          DisplayLabel: 'Antal och enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        FaktBelopp: {
          AttributeName: 'FaktBelopp',
          DisplayLabel: 'FaktBelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
        },
        Belopp2: {
          AttributeName: 'Belopp2',
          DisplayLabel: 'Belopp2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SkotselPaket: {
          AttributeName: 'SkotselPaket',
          DisplayLabel: 'Paket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SkotselPaketInfo: {
          AttributeName: 'SkotselPaketInfo',
          DisplayLabel: 'Ingår i paket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatusBenAgresso: {
          AttributeName: 'StatusBenAgresso',
          DisplayLabel: 'Status elektronisk faktura',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Agresso',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        OrderOmg: {
          AssociationName: 'OrderOmg',
          DisplayLabel: 'Orderomgång',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAOrderOmg',
          AssociatedComponentName: 'OrderOmg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Orderrad: {
          AssociationName: 'Orderrad',
          DisplayLabel: 'Orderrad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrderrad',
          AssociatedComponentName: 'Artikelrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Skotsel: {
          AssociationName: 'Skotsel',
          DisplayLabel: 'Skötsel',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    GAArbUndSkotsel: {
      CollectionName: 'GAArbUndSkotsel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArbUndSkotsel',
        Abstract: false,
        SOLabel: 'Årsskötsel',
        SOGLabel: 'Årsskötsel',
        SBLabel: 'Årsskötseln',
        SBGLabel: 'Årsskötseln',
        POLabel: 'Årsskötslar',
        POGLabel: 'Årsskötslar',
        PBLabel: 'Årsskötslarna',
        PBGLabel: 'Årsskötslarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Årsskötseln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Årsskötseln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Årsskötseln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Årsskötseln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKOTSEL_ID: {
          AttributeName: 'SKOTSEL_ID',
          DisplayLabel: 'Skötsel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKOTSEL_LOPNR: {
          AttributeName: 'SKOTSEL_LOPNR',
          DisplayLabel: 'Skötsel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AR: {
          AttributeName: 'AR',
          DisplayLabel: 'År',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DATUMKOD: {
          AttributeName: 'DATUMKOD',
          DisplayLabel: 'Datumkod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="12"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        DAG: {
          AttributeName: 'DAG',
          DisplayLabel: 'Dag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="1";MaxValue="99"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        UTSKRIFT_PL: {
          AttributeName: 'UTSKRIFT_PL',
          DisplayLabel: 'Skriv ut på arbetsunderlag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PAKET: {
          AttributeName: 'PAKET',
          DisplayLabel: 'Paket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PAKET_INFO: {
          AttributeName: 'PAKET_INFO',
          DisplayLabel: 'Paket',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        ArbUndNr: {
          AttributeName: 'ArbUndNr',
          DisplayLabel: 'Arbetsunderlag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArbUndRubrik: {
          AttributeName: 'ArbUndRubrik',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArbUndStatusText: {
          AttributeName: 'ArbUndStatusText',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArbUndSkapat: {
          AttributeName: 'ArbUndSkapat',
          DisplayLabel: 'Skapat',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArbUndUtskrivet: {
          AttributeName: 'ArbUndUtskrivet',
          DisplayLabel: 'Utskrivet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        GravNr: {
          AttributeName: 'GravNr',
          DisplayLabel: 'Gravplatsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Gravnummer: {
          AttributeName: 'Gravnummer',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Kvarter: {
          AttributeName: 'Kvarter',
          DisplayLabel: 'Benämning kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Artikelnr: {
          AttributeName: 'Artikelnr',
          DisplayLabel: 'Artikel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningStr: {
          AttributeName: 'BenamningStr',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Kort benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalEnhet: {
          AttributeName: 'AntalEnhet',
          DisplayLabel: 'Antal och enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EnhetAntalDec: {
          AttributeName: 'EnhetAntalDec',
          DisplayLabel: 'Antal decimaler',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Debsatt: {
          AttributeName: 'Debsatt',
          DisplayLabel: 'Debiteringssätt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DebsattKod: {
          AttributeName: 'DebsattKod',
          DisplayLabel: 'Debiteringssätt, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SkotselPaket: {
          AttributeName: 'SkotselPaket',
          DisplayLabel: 'Paket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SkotselPaketInfo: {
          AttributeName: 'SkotselPaketInfo',
          DisplayLabel: 'Ingår i paket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ExtraInfo: {
          AttributeName: 'ExtraInfo',
          DisplayLabel: 'Övrigt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        MANAD2: {
          AttributeName: 'MANAD2',
          DisplayLabel: 'Månad',
          DataType: 'Int',
          Attribute: 'None',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Arbetsunderlag: {
          AssociationName: 'Arbetsunderlag',
          DisplayLabel: 'Arbetsunderlag',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAArbUnd',
          AssociatedComponentName: 'ArbUnd',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Skotsel: {
          AssociationName: 'Skotsel',
          DisplayLabel: 'Skötsel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Grav: {
          AssociationName: 'Grav',
          DisplayLabel: 'Grav',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAGrav',
          AssociatedComponentName: 'Grav',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default GA;
